function bt(o) {
  throw new Error('Could not dynamically require "' + o + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Xt = { exports: {} };
(function(o, t) {
  (function(n) {
    o.exports = n();
  })(function() {
    return function n(a, d, m) {
      function b(S, A) {
        if (!d[S]) {
          if (!a[S]) {
            var P = typeof bt == "function" && bt;
            if (!A && P)
              return P(S, !0);
            if (I)
              return I(S, !0);
            throw new Error("Cannot find module '" + S + "'");
          }
          A = d[S] = { exports: {} }, a[S][0].call(A.exports, function(T) {
            var V = a[S][1][T];
            return b(V || T);
          }, A, A.exports, n, a, d, m);
        }
        return d[S].exports;
      }
      for (var I = typeof bt == "function" && bt, M = 0; M < m.length; M++)
        b(m[M]);
      return b;
    }({ 1: [function(n, a, d) {
      (function(m, b, I, M, S, A, P, T, V) {
        var y = n("crypto");
        function C(l, g) {
          g = L(l, g);
          var s;
          return (s = g.algorithm !== "passthrough" ? y.createHash(g.algorithm) : new B()).write === void 0 && (s.write = s.update, s.end = s.update), O(g, s).dispatch(l), s.update || s.end(""), s.digest ? s.digest(g.encoding === "buffer" ? void 0 : g.encoding) : (l = s.read(), g.encoding !== "buffer" ? l.toString(g.encoding) : l);
        }
        (d = a.exports = C).sha1 = function(l) {
          return C(l);
        }, d.keys = function(l) {
          return C(l, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
        }, d.MD5 = function(l) {
          return C(l, { algorithm: "md5", encoding: "hex" });
        }, d.keysMD5 = function(l) {
          return C(l, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
        };
        var h = y.getHashes ? y.getHashes().slice() : ["sha1", "md5"], E = (h.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
        function L(l, g) {
          var s = {};
          if (s.algorithm = (g = g || {}).algorithm || "sha1", s.encoding = g.encoding || "hex", s.excludeValues = !!g.excludeValues, s.algorithm = s.algorithm.toLowerCase(), s.encoding = s.encoding.toLowerCase(), s.ignoreUnknown = g.ignoreUnknown === !0, s.respectType = g.respectType !== !1, s.respectFunctionNames = g.respectFunctionNames !== !1, s.respectFunctionProperties = g.respectFunctionProperties !== !1, s.unorderedArrays = g.unorderedArrays === !0, s.unorderedSets = g.unorderedSets !== !1, s.unorderedObjects = g.unorderedObjects !== !1, s.replacer = g.replacer || void 0, s.excludeKeys = g.excludeKeys || void 0, l === void 0)
            throw new Error("Object argument required.");
          for (var u = 0; u < h.length; ++u)
            h[u].toLowerCase() === s.algorithm.toLowerCase() && (s.algorithm = h[u]);
          if (h.indexOf(s.algorithm) === -1)
            throw new Error('Algorithm "' + s.algorithm + '"  not supported. supported values: ' + h.join(", "));
          if (E.indexOf(s.encoding) === -1 && s.algorithm !== "passthrough")
            throw new Error('Encoding "' + s.encoding + '"  not supported. supported values: ' + E.join(", "));
          return s;
        }
        function _(l) {
          if (typeof l == "function")
            return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(l)) != null;
        }
        function O(l, g, s) {
          s = s || [];
          function u(i) {
            return g.update ? g.update(i, "utf8") : g.write(i, "utf8");
          }
          return { dispatch: function(i) {
            return this["_" + ((i = l.replacer ? l.replacer(i) : i) === null ? "null" : typeof i)](i);
          }, _object: function(i) {
            var c, p = Object.prototype.toString.call(i), j = /\[object (.*)\]/i.exec(p);
            if (j = (j = j ? j[1] : "unknown:[" + p + "]").toLowerCase(), 0 <= (p = s.indexOf(i)))
              return this.dispatch("[CIRCULAR:" + p + "]");
            if (s.push(i), I !== void 0 && I.isBuffer && I.isBuffer(i))
              return u("buffer:"), u(i);
            if (j === "object" || j === "function" || j === "asyncfunction")
              return p = Object.keys(i), l.unorderedObjects && (p = p.sort()), l.respectType === !1 || _(i) || p.splice(0, 0, "prototype", "__proto__", "constructor"), l.excludeKeys && (p = p.filter(function(R) {
                return !l.excludeKeys(R);
              })), u("object:" + p.length + ":"), c = this, p.forEach(function(R) {
                c.dispatch(R), u(":"), l.excludeValues || c.dispatch(i[R]), u(",");
              });
            if (!this["_" + j]) {
              if (l.ignoreUnknown)
                return u("[" + j + "]");
              throw new Error('Unknown object type "' + j + '"');
            }
            this["_" + j](i);
          }, _array: function(i, R) {
            R = R !== void 0 ? R : l.unorderedArrays !== !1;
            var p = this;
            if (u("array:" + i.length + ":"), !R || i.length <= 1)
              return i.forEach(function(x) {
                return p.dispatch(x);
              });
            var j = [], R = i.map(function(x) {
              var D = new B(), z = s.slice();
              return O(l, D, z).dispatch(x), j = j.concat(z.slice(s.length)), D.read().toString();
            });
            return s = s.concat(j), R.sort(), this._array(R, !1);
          }, _date: function(i) {
            return u("date:" + i.toJSON());
          }, _symbol: function(i) {
            return u("symbol:" + i.toString());
          }, _error: function(i) {
            return u("error:" + i.toString());
          }, _boolean: function(i) {
            return u("bool:" + i.toString());
          }, _string: function(i) {
            u("string:" + i.length + ":"), u(i.toString());
          }, _function: function(i) {
            u("fn:"), _(i) ? this.dispatch("[native]") : this.dispatch(i.toString()), l.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(i.name)), l.respectFunctionProperties && this._object(i);
          }, _number: function(i) {
            return u("number:" + i.toString());
          }, _xml: function(i) {
            return u("xml:" + i.toString());
          }, _null: function() {
            return u("Null");
          }, _undefined: function() {
            return u("Undefined");
          }, _regexp: function(i) {
            return u("regex:" + i.toString());
          }, _uint8array: function(i) {
            return u("uint8array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _uint8clampedarray: function(i) {
            return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(i));
          }, _int8array: function(i) {
            return u("int8array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _uint16array: function(i) {
            return u("uint16array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _int16array: function(i) {
            return u("int16array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _uint32array: function(i) {
            return u("uint32array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _int32array: function(i) {
            return u("int32array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _float32array: function(i) {
            return u("float32array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _float64array: function(i) {
            return u("float64array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _arraybuffer: function(i) {
            return u("arraybuffer:"), this.dispatch(new Uint8Array(i));
          }, _url: function(i) {
            return u("url:" + i.toString());
          }, _map: function(i) {
            return u("map:"), i = Array.from(i), this._array(i, l.unorderedSets !== !1);
          }, _set: function(i) {
            return u("set:"), i = Array.from(i), this._array(i, l.unorderedSets !== !1);
          }, _file: function(i) {
            return u("file:"), this.dispatch([i.name, i.size, i.type, i.lastModfied]);
          }, _blob: function() {
            if (l.ignoreUnknown)
              return u("[blob]");
            throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
          }, _domwindow: function() {
            return u("domwindow");
          }, _bigint: function(i) {
            return u("bigint:" + i.toString());
          }, _process: function() {
            return u("process");
          }, _timer: function() {
            return u("timer");
          }, _pipe: function() {
            return u("pipe");
          }, _tcp: function() {
            return u("tcp");
          }, _udp: function() {
            return u("udp");
          }, _tty: function() {
            return u("tty");
          }, _statwatcher: function() {
            return u("statwatcher");
          }, _securecontext: function() {
            return u("securecontext");
          }, _connection: function() {
            return u("connection");
          }, _zlib: function() {
            return u("zlib");
          }, _context: function() {
            return u("context");
          }, _nodescript: function() {
            return u("nodescript");
          }, _httpparser: function() {
            return u("httpparser");
          }, _dataview: function() {
            return u("dataview");
          }, _signal: function() {
            return u("signal");
          }, _fsevent: function() {
            return u("fsevent");
          }, _tlswrap: function() {
            return u("tlswrap");
          } };
        }
        function B() {
          return { buf: "", write: function(l) {
            this.buf += l;
          }, end: function(l) {
            this.buf += l;
          }, read: function() {
            return this.buf;
          } };
        }
        d.writeToStream = function(l, g, s) {
          return s === void 0 && (s = g, g = {}), O(g = L(l, g), s).dispatch(l);
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
    }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(n, a, d) {
      (function(m, b, I, M, S, A, P, T, V) {
        (function(y) {
          var C = typeof Uint8Array < "u" ? Uint8Array : Array, h = "+".charCodeAt(0), E = "/".charCodeAt(0), L = "0".charCodeAt(0), _ = "a".charCodeAt(0), O = "A".charCodeAt(0), B = "-".charCodeAt(0), l = "_".charCodeAt(0);
          function g(s) {
            return s = s.charCodeAt(0), s === h || s === B ? 62 : s === E || s === l ? 63 : s < L ? -1 : s < L + 10 ? s - L + 26 + 26 : s < O + 26 ? s - O : s < _ + 26 ? s - _ + 26 : void 0;
          }
          y.toByteArray = function(s) {
            var u, i;
            if (0 < s.length % 4)
              throw new Error("Invalid string. Length must be a multiple of 4");
            var c = s.length, c = s.charAt(c - 2) === "=" ? 2 : s.charAt(c - 1) === "=" ? 1 : 0, p = new C(3 * s.length / 4 - c), j = 0 < c ? s.length - 4 : s.length, R = 0;
            function x(D) {
              p[R++] = D;
            }
            for (u = 0; u < j; u += 4, 0)
              x((16711680 & (i = g(s.charAt(u)) << 18 | g(s.charAt(u + 1)) << 12 | g(s.charAt(u + 2)) << 6 | g(s.charAt(u + 3)))) >> 16), x((65280 & i) >> 8), x(255 & i);
            return c == 2 ? x(255 & (i = g(s.charAt(u)) << 2 | g(s.charAt(u + 1)) >> 4)) : c == 1 && (x((i = g(s.charAt(u)) << 10 | g(s.charAt(u + 1)) << 4 | g(s.charAt(u + 2)) >> 2) >> 8 & 255), x(255 & i)), p;
          }, y.fromByteArray = function(s) {
            var u, i, c, p, j = s.length % 3, R = "";
            function x(D) {
              return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(D);
            }
            for (u = 0, c = s.length - j; u < c; u += 3)
              i = (s[u] << 16) + (s[u + 1] << 8) + s[u + 2], R += x((p = i) >> 18 & 63) + x(p >> 12 & 63) + x(p >> 6 & 63) + x(63 & p);
            switch (j) {
              case 1:
                R = (R += x((i = s[s.length - 1]) >> 2)) + x(i << 4 & 63) + "==";
                break;
              case 2:
                R = (R = (R += x((i = (s[s.length - 2] << 8) + s[s.length - 1]) >> 10)) + x(i >> 4 & 63)) + x(i << 2 & 63) + "=";
            }
            return R;
          };
        })(d === void 0 ? this.base64js = {} : d);
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
    }, { buffer: 3, lYpoI2: 11 }], 3: [function(n, a, d) {
      (function(m, b, h, M, S, A, P, T, V) {
        var y = n("base64-js"), C = n("ieee754");
        function h(e, r, f) {
          if (!(this instanceof h))
            return new h(e, r, f);
          var v, w, k, $, J = typeof e;
          if (r === "base64" && J == "string")
            for (e = ($ = e).trim ? $.trim() : $.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0; )
              e += "=";
          if (J == "number")
            v = K(e);
          else if (J == "string")
            v = h.byteLength(e, r);
          else {
            if (J != "object")
              throw new Error("First argument needs to be a number, array or string.");
            v = K(e.length);
          }
          if (h._useTypedArrays ? w = h._augment(new Uint8Array(v)) : ((w = this).length = v, w._isBuffer = !0), h._useTypedArrays && typeof e.byteLength == "number")
            w._set(e);
          else if (q($ = e) || h.isBuffer($) || $ && typeof $ == "object" && typeof $.length == "number")
            for (k = 0; k < v; k++)
              h.isBuffer(e) ? w[k] = e.readUInt8(k) : w[k] = e[k];
          else if (J == "string")
            w.write(e, 0, r);
          else if (J == "number" && !h._useTypedArrays && !f)
            for (k = 0; k < v; k++)
              w[k] = 0;
          return w;
        }
        function E(e, r, f, v) {
          return h._charsWritten = yt(function(w) {
            for (var k = [], $ = 0; $ < w.length; $++)
              k.push(255 & w.charCodeAt($));
            return k;
          }(r), e, f, v);
        }
        function L(e, r, f, v) {
          return h._charsWritten = yt(function(w) {
            for (var k, $, J = [], Y = 0; Y < w.length; Y++)
              $ = w.charCodeAt(Y), k = $ >> 8, $ = $ % 256, J.push($), J.push(k);
            return J;
          }(r), e, f, v);
        }
        function _(e, r, f) {
          var v = "";
          f = Math.min(e.length, f);
          for (var w = r; w < f; w++)
            v += String.fromCharCode(e[w]);
          return v;
        }
        function O(e, r, f, k) {
          k || (U(typeof f == "boolean", "missing or invalid endian"), U(r != null, "missing offset"), U(r + 1 < e.length, "Trying to read beyond buffer length"));
          var w, k = e.length;
          if (!(k <= r))
            return f ? (w = e[r], r + 1 < k && (w |= e[r + 1] << 8)) : (w = e[r] << 8, r + 1 < k && (w |= e[r + 1])), w;
        }
        function B(e, r, f, k) {
          k || (U(typeof f == "boolean", "missing or invalid endian"), U(r != null, "missing offset"), U(r + 3 < e.length, "Trying to read beyond buffer length"));
          var w, k = e.length;
          if (!(k <= r))
            return f ? (r + 2 < k && (w = e[r + 2] << 16), r + 1 < k && (w |= e[r + 1] << 8), w |= e[r], r + 3 < k && (w += e[r + 3] << 24 >>> 0)) : (r + 1 < k && (w = e[r + 1] << 16), r + 2 < k && (w |= e[r + 2] << 8), r + 3 < k && (w |= e[r + 3]), w += e[r] << 24 >>> 0), w;
        }
        function l(e, r, f, v) {
          if (v || (U(typeof f == "boolean", "missing or invalid endian"), U(r != null, "missing offset"), U(r + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= r))
            return v = O(e, r, f, !0), 32768 & v ? -1 * (65535 - v + 1) : v;
        }
        function g(e, r, f, v) {
          if (v || (U(typeof f == "boolean", "missing or invalid endian"), U(r != null, "missing offset"), U(r + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= r))
            return v = B(e, r, f, !0), 2147483648 & v ? -1 * (4294967295 - v + 1) : v;
        }
        function s(e, r, f, v) {
          return v || (U(typeof f == "boolean", "missing or invalid endian"), U(r + 3 < e.length, "Trying to read beyond buffer length")), C.read(e, r, f, 23, 4);
        }
        function u(e, r, f, v) {
          return v || (U(typeof f == "boolean", "missing or invalid endian"), U(r + 7 < e.length, "Trying to read beyond buffer length")), C.read(e, r, f, 52, 8);
        }
        function i(e, r, f, v, w) {
          if (w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f != null, "missing offset"), U(f + 1 < e.length, "trying to write beyond buffer length"), At(r, 65535)), w = e.length, !(w <= f))
            for (var k = 0, $ = Math.min(w - f, 2); k < $; k++)
              e[f + k] = (r & 255 << 8 * (v ? k : 1 - k)) >>> 8 * (v ? k : 1 - k);
        }
        function c(e, r, f, v, w) {
          if (w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f != null, "missing offset"), U(f + 3 < e.length, "trying to write beyond buffer length"), At(r, 4294967295)), w = e.length, !(w <= f))
            for (var k = 0, $ = Math.min(w - f, 4); k < $; k++)
              e[f + k] = r >>> 8 * (v ? k : 3 - k) & 255;
        }
        function p(e, r, f, v, w) {
          w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f != null, "missing offset"), U(f + 1 < e.length, "Trying to write beyond buffer length"), Lt(r, 32767, -32768)), e.length <= f || i(e, 0 <= r ? r : 65535 + r + 1, f, v, w);
        }
        function j(e, r, f, v, w) {
          w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f != null, "missing offset"), U(f + 3 < e.length, "Trying to write beyond buffer length"), Lt(r, 2147483647, -2147483648)), e.length <= f || c(e, 0 <= r ? r : 4294967295 + r + 1, f, v, w);
        }
        function R(e, r, f, v, w) {
          w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f != null, "missing offset"), U(f + 3 < e.length, "Trying to write beyond buffer length"), Nt(r, 34028234663852886e22, -34028234663852886e22)), e.length <= f || C.write(e, r, f, v, 23, 4);
        }
        function x(e, r, f, v, w) {
          w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f != null, "missing offset"), U(f + 7 < e.length, "Trying to write beyond buffer length"), Nt(r, 17976931348623157e292, -17976931348623157e292)), e.length <= f || C.write(e, r, f, v, 52, 8);
        }
        d.Buffer = h, d.SlowBuffer = h, d.INSPECT_MAX_BYTES = 50, h.poolSize = 8192, h._useTypedArrays = function() {
          try {
            var e = new ArrayBuffer(0), r = new Uint8Array(e);
            return r.foo = function() {
              return 42;
            }, r.foo() === 42 && typeof r.subarray == "function";
          } catch {
            return !1;
          }
        }(), h.isEncoding = function(e) {
          switch (String(e).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "raw":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;
            default:
              return !1;
          }
        }, h.isBuffer = function(e) {
          return !(e == null || !e._isBuffer);
        }, h.byteLength = function(e, r) {
          var f;
          switch (e += "", r || "utf8") {
            case "hex":
              f = e.length / 2;
              break;
            case "utf8":
            case "utf-8":
              f = ot(e).length;
              break;
            case "ascii":
            case "binary":
            case "raw":
              f = e.length;
              break;
            case "base64":
              f = xt(e).length;
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              f = 2 * e.length;
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return f;
        }, h.concat = function(e, r) {
          if (U(q(e), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), e.length === 0)
            return new h(0);
          if (e.length === 1)
            return e[0];
          if (typeof r != "number")
            for (w = r = 0; w < e.length; w++)
              r += e[w].length;
          for (var f = new h(r), v = 0, w = 0; w < e.length; w++) {
            var k = e[w];
            k.copy(f, v), v += k.length;
          }
          return f;
        }, h.prototype.write = function(e, r, f, v) {
          isFinite(r) ? isFinite(f) || (v = f, f = void 0) : (Y = v, v = r, r = f, f = Y), r = Number(r) || 0;
          var w, k, $, J, Y = this.length - r;
          switch ((!f || Y < (f = Number(f))) && (f = Y), v = String(v || "utf8").toLowerCase()) {
            case "hex":
              w = function(et, Q, Z, H) {
                Z = Number(Z) || 0;
                var W = et.length - Z;
                (!H || W < (H = Number(H))) && (H = W), U((W = Q.length) % 2 == 0, "Invalid hex string"), W / 2 < H && (H = W / 2);
                for (var ht = 0; ht < H; ht++) {
                  var Vt = parseInt(Q.substr(2 * ht, 2), 16);
                  U(!isNaN(Vt), "Invalid hex string"), et[Z + ht] = Vt;
                }
                return h._charsWritten = 2 * ht, ht;
              }(this, e, r, f);
              break;
            case "utf8":
            case "utf-8":
              k = this, $ = r, J = f, w = h._charsWritten = yt(ot(e), k, $, J);
              break;
            case "ascii":
            case "binary":
              w = E(this, e, r, f);
              break;
            case "base64":
              k = this, $ = r, J = f, w = h._charsWritten = yt(xt(e), k, $, J);
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              w = L(this, e, r, f);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return w;
        }, h.prototype.toString = function(e, r, f) {
          var v, w, k, $, J = this;
          if (e = String(e || "utf8").toLowerCase(), r = Number(r) || 0, (f = f !== void 0 ? Number(f) : J.length) === r)
            return "";
          switch (e) {
            case "hex":
              v = function(Y, et, Q) {
                var Z = Y.length;
                (!et || et < 0) && (et = 0), (!Q || Q < 0 || Z < Q) && (Q = Z);
                for (var H = "", W = et; W < Q; W++)
                  H += F(Y[W]);
                return H;
              }(J, r, f);
              break;
            case "utf8":
            case "utf-8":
              v = function(Y, et, Q) {
                var Z = "", H = "";
                Q = Math.min(Y.length, Q);
                for (var W = et; W < Q; W++)
                  Y[W] <= 127 ? (Z += Tt(H) + String.fromCharCode(Y[W]), H = "") : H += "%" + Y[W].toString(16);
                return Z + Tt(H);
              }(J, r, f);
              break;
            case "ascii":
            case "binary":
              v = _(J, r, f);
              break;
            case "base64":
              w = J, $ = f, v = (k = r) === 0 && $ === w.length ? y.fromByteArray(w) : y.fromByteArray(w.slice(k, $));
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              v = function(Y, et, Q) {
                for (var Z = Y.slice(et, Q), H = "", W = 0; W < Z.length; W += 2)
                  H += String.fromCharCode(Z[W] + 256 * Z[W + 1]);
                return H;
              }(J, r, f);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return v;
        }, h.prototype.toJSON = function() {
          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
        }, h.prototype.copy = function(e, r, f, v) {
          if (r = r || 0, (v = v || v === 0 ? v : this.length) !== (f = f || 0) && e.length !== 0 && this.length !== 0) {
            U(f <= v, "sourceEnd < sourceStart"), U(0 <= r && r < e.length, "targetStart out of bounds"), U(0 <= f && f < this.length, "sourceStart out of bounds"), U(0 <= v && v <= this.length, "sourceEnd out of bounds"), v > this.length && (v = this.length);
            var w = (v = e.length - r < v - f ? e.length - r + f : v) - f;
            if (w < 100 || !h._useTypedArrays)
              for (var k = 0; k < w; k++)
                e[k + r] = this[k + f];
            else
              e._set(this.subarray(f, f + w), r);
          }
        }, h.prototype.slice = function(e, r) {
          var f = this.length;
          if (e = z(e, f, 0), r = z(r, f, f), h._useTypedArrays)
            return h._augment(this.subarray(e, r));
          for (var v = r - e, w = new h(v, void 0, !0), k = 0; k < v; k++)
            w[k] = this[k + e];
          return w;
        }, h.prototype.get = function(e) {
          return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
        }, h.prototype.set = function(e, r) {
          return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, r);
        }, h.prototype.readUInt8 = function(e, r) {
          if (r || (U(e != null, "missing offset"), U(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length))
            return this[e];
        }, h.prototype.readUInt16LE = function(e, r) {
          return O(this, e, !0, r);
        }, h.prototype.readUInt16BE = function(e, r) {
          return O(this, e, !1, r);
        }, h.prototype.readUInt32LE = function(e, r) {
          return B(this, e, !0, r);
        }, h.prototype.readUInt32BE = function(e, r) {
          return B(this, e, !1, r);
        }, h.prototype.readInt8 = function(e, r) {
          if (r || (U(e != null, "missing offset"), U(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length))
            return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
        }, h.prototype.readInt16LE = function(e, r) {
          return l(this, e, !0, r);
        }, h.prototype.readInt16BE = function(e, r) {
          return l(this, e, !1, r);
        }, h.prototype.readInt32LE = function(e, r) {
          return g(this, e, !0, r);
        }, h.prototype.readInt32BE = function(e, r) {
          return g(this, e, !1, r);
        }, h.prototype.readFloatLE = function(e, r) {
          return s(this, e, !0, r);
        }, h.prototype.readFloatBE = function(e, r) {
          return s(this, e, !1, r);
        }, h.prototype.readDoubleLE = function(e, r) {
          return u(this, e, !0, r);
        }, h.prototype.readDoubleBE = function(e, r) {
          return u(this, e, !1, r);
        }, h.prototype.writeUInt8 = function(e, r, f) {
          f || (U(e != null, "missing value"), U(r != null, "missing offset"), U(r < this.length, "trying to write beyond buffer length"), At(e, 255)), r >= this.length || (this[r] = e);
        }, h.prototype.writeUInt16LE = function(e, r, f) {
          i(this, e, r, !0, f);
        }, h.prototype.writeUInt16BE = function(e, r, f) {
          i(this, e, r, !1, f);
        }, h.prototype.writeUInt32LE = function(e, r, f) {
          c(this, e, r, !0, f);
        }, h.prototype.writeUInt32BE = function(e, r, f) {
          c(this, e, r, !1, f);
        }, h.prototype.writeInt8 = function(e, r, f) {
          f || (U(e != null, "missing value"), U(r != null, "missing offset"), U(r < this.length, "Trying to write beyond buffer length"), Lt(e, 127, -128)), r >= this.length || (0 <= e ? this.writeUInt8(e, r, f) : this.writeUInt8(255 + e + 1, r, f));
        }, h.prototype.writeInt16LE = function(e, r, f) {
          p(this, e, r, !0, f);
        }, h.prototype.writeInt16BE = function(e, r, f) {
          p(this, e, r, !1, f);
        }, h.prototype.writeInt32LE = function(e, r, f) {
          j(this, e, r, !0, f);
        }, h.prototype.writeInt32BE = function(e, r, f) {
          j(this, e, r, !1, f);
        }, h.prototype.writeFloatLE = function(e, r, f) {
          R(this, e, r, !0, f);
        }, h.prototype.writeFloatBE = function(e, r, f) {
          R(this, e, r, !1, f);
        }, h.prototype.writeDoubleLE = function(e, r, f) {
          x(this, e, r, !0, f);
        }, h.prototype.writeDoubleBE = function(e, r, f) {
          x(this, e, r, !1, f);
        }, h.prototype.fill = function(e, r, f) {
          if (r = r || 0, f = f || this.length, U(typeof (e = typeof (e = e || 0) == "string" ? e.charCodeAt(0) : e) == "number" && !isNaN(e), "value is not a number"), U(r <= f, "end < start"), f !== r && this.length !== 0) {
            U(0 <= r && r < this.length, "start out of bounds"), U(0 <= f && f <= this.length, "end out of bounds");
            for (var v = r; v < f; v++)
              this[v] = e;
          }
        }, h.prototype.inspect = function() {
          for (var e = [], r = this.length, f = 0; f < r; f++)
            if (e[f] = F(this[f]), f === d.INSPECT_MAX_BYTES) {
              e[f + 1] = "...";
              break;
            }
          return "<Buffer " + e.join(" ") + ">";
        }, h.prototype.toArrayBuffer = function() {
          if (typeof Uint8Array > "u")
            throw new Error("Buffer.toArrayBuffer not supported in this browser");
          if (h._useTypedArrays)
            return new h(this).buffer;
          for (var e = new Uint8Array(this.length), r = 0, f = e.length; r < f; r += 1)
            e[r] = this[r];
          return e.buffer;
        };
        var D = h.prototype;
        function z(e, r, f) {
          return typeof e != "number" ? f : r <= (e = ~~e) ? r : 0 <= e || 0 <= (e += r) ? e : 0;
        }
        function K(e) {
          return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
        }
        function q(e) {
          return (Array.isArray || function(r) {
            return Object.prototype.toString.call(r) === "[object Array]";
          })(e);
        }
        function F(e) {
          return e < 16 ? "0" + e.toString(16) : e.toString(16);
        }
        function ot(e) {
          for (var r = [], f = 0; f < e.length; f++) {
            var v = e.charCodeAt(f);
            if (v <= 127)
              r.push(e.charCodeAt(f));
            else
              for (var w = f, k = (55296 <= v && v <= 57343 && f++, encodeURIComponent(e.slice(w, f + 1)).substr(1).split("%")), $ = 0; $ < k.length; $++)
                r.push(parseInt(k[$], 16));
          }
          return r;
        }
        function xt(e) {
          return y.toByteArray(e);
        }
        function yt(e, r, f, v) {
          for (var w = 0; w < v && !(w + f >= r.length || w >= e.length); w++)
            r[w + f] = e[w];
          return w;
        }
        function Tt(e) {
          try {
            return decodeURIComponent(e);
          } catch {
            return String.fromCharCode(65533);
          }
        }
        function At(e, r) {
          U(typeof e == "number", "cannot write a non-number as a number"), U(0 <= e, "specified a negative value for writing an unsigned value"), U(e <= r, "value is larger than maximum value for type"), U(Math.floor(e) === e, "value has a fractional component");
        }
        function Lt(e, r, f) {
          U(typeof e == "number", "cannot write a non-number as a number"), U(e <= r, "value larger than maximum allowed value"), U(f <= e, "value smaller than minimum allowed value"), U(Math.floor(e) === e, "value has a fractional component");
        }
        function Nt(e, r, f) {
          U(typeof e == "number", "cannot write a non-number as a number"), U(e <= r, "value larger than maximum allowed value"), U(f <= e, "value smaller than minimum allowed value");
        }
        function U(e, r) {
          if (!e)
            throw new Error(r || "Failed assertion");
        }
        h._augment = function(e) {
          return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = D.get, e.set = D.set, e.write = D.write, e.toString = D.toString, e.toLocaleString = D.toString, e.toJSON = D.toJSON, e.copy = D.copy, e.slice = D.slice, e.readUInt8 = D.readUInt8, e.readUInt16LE = D.readUInt16LE, e.readUInt16BE = D.readUInt16BE, e.readUInt32LE = D.readUInt32LE, e.readUInt32BE = D.readUInt32BE, e.readInt8 = D.readInt8, e.readInt16LE = D.readInt16LE, e.readInt16BE = D.readInt16BE, e.readInt32LE = D.readInt32LE, e.readInt32BE = D.readInt32BE, e.readFloatLE = D.readFloatLE, e.readFloatBE = D.readFloatBE, e.readDoubleLE = D.readDoubleLE, e.readDoubleBE = D.readDoubleBE, e.writeUInt8 = D.writeUInt8, e.writeUInt16LE = D.writeUInt16LE, e.writeUInt16BE = D.writeUInt16BE, e.writeUInt32LE = D.writeUInt32LE, e.writeUInt32BE = D.writeUInt32BE, e.writeInt8 = D.writeInt8, e.writeInt16LE = D.writeInt16LE, e.writeInt16BE = D.writeInt16BE, e.writeInt32LE = D.writeInt32LE, e.writeInt32BE = D.writeInt32BE, e.writeFloatLE = D.writeFloatLE, e.writeFloatBE = D.writeFloatBE, e.writeDoubleLE = D.writeDoubleLE, e.writeDoubleBE = D.writeDoubleBE, e.fill = D.fill, e.inspect = D.inspect, e.toArrayBuffer = D.toArrayBuffer, e;
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
    }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(n, a, d) {
      (function(m, b, y, M, S, A, P, T, V) {
        var y = n("buffer").Buffer, C = 4, h = new y(C);
        h.fill(0), a.exports = { hash: function(E, L, _, O) {
          for (var B = L(function(i, c) {
            i.length % C != 0 && (p = i.length + (C - i.length % C), i = y.concat([i, h], p));
            for (var p, j = [], R = c ? i.readInt32BE : i.readInt32LE, x = 0; x < i.length; x += C)
              j.push(R.call(i, x));
            return j;
          }(E = y.isBuffer(E) ? E : new y(E), O), 8 * E.length), L = O, l = new y(_), g = L ? l.writeInt32BE : l.writeInt32LE, s = 0; s < B.length; s++)
            g.call(l, B[s], 4 * s, !0);
          return l;
        } };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { buffer: 3, lYpoI2: 11 }], 5: [function(n, a, d) {
      (function(m, b, y, M, S, A, P, T, V) {
        var y = n("buffer").Buffer, C = n("./sha"), h = n("./sha256"), E = n("./rng"), L = { sha1: C, sha256: h, md5: n("./md5") }, _ = 64, O = new y(_);
        function B(i, c) {
          var p = L[i = i || "sha1"], j = [];
          return p || l("algorithm:", i, "is not yet supported"), { update: function(R) {
            return y.isBuffer(R) || (R = new y(R)), j.push(R), R.length, this;
          }, digest: function(R) {
            var x = y.concat(j), x = c ? function(D, z, K) {
              y.isBuffer(z) || (z = new y(z)), y.isBuffer(K) || (K = new y(K)), z.length > _ ? z = D(z) : z.length < _ && (z = y.concat([z, O], _));
              for (var q = new y(_), F = new y(_), ot = 0; ot < _; ot++)
                q[ot] = 54 ^ z[ot], F[ot] = 92 ^ z[ot];
              return K = D(y.concat([q, K])), D(y.concat([F, K]));
            }(p, c, x) : p(x);
            return j = null, R ? x.toString(R) : x;
          } };
        }
        function l() {
          var i = [].slice.call(arguments).join(" ");
          throw new Error([i, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
        }
        O.fill(0), d.createHash = function(i) {
          return B(i);
        }, d.createHmac = B, d.randomBytes = function(i, c) {
          if (!c || !c.call)
            return new y(E(i));
          try {
            c.call(this, void 0, new y(E(i)));
          } catch (p) {
            c(p);
          }
        };
        var g, s = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], u = function(i) {
          d[i] = function() {
            l("sorry,", i, "is not implemented yet");
          };
        };
        for (g in s)
          u(s[g]);
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(n, a, d) {
      (function(m, b, I, M, S, A, P, T, V) {
        var y = n("./helpers");
        function C(l, g) {
          l[g >> 5] |= 128 << g % 32, l[14 + (g + 64 >>> 9 << 4)] = g;
          for (var s = 1732584193, u = -271733879, i = -1732584194, c = 271733878, p = 0; p < l.length; p += 16) {
            var j = s, R = u, x = i, D = c, s = E(s, u, i, c, l[p + 0], 7, -680876936), c = E(c, s, u, i, l[p + 1], 12, -389564586), i = E(i, c, s, u, l[p + 2], 17, 606105819), u = E(u, i, c, s, l[p + 3], 22, -1044525330);
            s = E(s, u, i, c, l[p + 4], 7, -176418897), c = E(c, s, u, i, l[p + 5], 12, 1200080426), i = E(i, c, s, u, l[p + 6], 17, -1473231341), u = E(u, i, c, s, l[p + 7], 22, -45705983), s = E(s, u, i, c, l[p + 8], 7, 1770035416), c = E(c, s, u, i, l[p + 9], 12, -1958414417), i = E(i, c, s, u, l[p + 10], 17, -42063), u = E(u, i, c, s, l[p + 11], 22, -1990404162), s = E(s, u, i, c, l[p + 12], 7, 1804603682), c = E(c, s, u, i, l[p + 13], 12, -40341101), i = E(i, c, s, u, l[p + 14], 17, -1502002290), s = L(s, u = E(u, i, c, s, l[p + 15], 22, 1236535329), i, c, l[p + 1], 5, -165796510), c = L(c, s, u, i, l[p + 6], 9, -1069501632), i = L(i, c, s, u, l[p + 11], 14, 643717713), u = L(u, i, c, s, l[p + 0], 20, -373897302), s = L(s, u, i, c, l[p + 5], 5, -701558691), c = L(c, s, u, i, l[p + 10], 9, 38016083), i = L(i, c, s, u, l[p + 15], 14, -660478335), u = L(u, i, c, s, l[p + 4], 20, -405537848), s = L(s, u, i, c, l[p + 9], 5, 568446438), c = L(c, s, u, i, l[p + 14], 9, -1019803690), i = L(i, c, s, u, l[p + 3], 14, -187363961), u = L(u, i, c, s, l[p + 8], 20, 1163531501), s = L(s, u, i, c, l[p + 13], 5, -1444681467), c = L(c, s, u, i, l[p + 2], 9, -51403784), i = L(i, c, s, u, l[p + 7], 14, 1735328473), s = _(s, u = L(u, i, c, s, l[p + 12], 20, -1926607734), i, c, l[p + 5], 4, -378558), c = _(c, s, u, i, l[p + 8], 11, -2022574463), i = _(i, c, s, u, l[p + 11], 16, 1839030562), u = _(u, i, c, s, l[p + 14], 23, -35309556), s = _(s, u, i, c, l[p + 1], 4, -1530992060), c = _(c, s, u, i, l[p + 4], 11, 1272893353), i = _(i, c, s, u, l[p + 7], 16, -155497632), u = _(u, i, c, s, l[p + 10], 23, -1094730640), s = _(s, u, i, c, l[p + 13], 4, 681279174), c = _(c, s, u, i, l[p + 0], 11, -358537222), i = _(i, c, s, u, l[p + 3], 16, -722521979), u = _(u, i, c, s, l[p + 6], 23, 76029189), s = _(s, u, i, c, l[p + 9], 4, -640364487), c = _(c, s, u, i, l[p + 12], 11, -421815835), i = _(i, c, s, u, l[p + 15], 16, 530742520), s = O(s, u = _(u, i, c, s, l[p + 2], 23, -995338651), i, c, l[p + 0], 6, -198630844), c = O(c, s, u, i, l[p + 7], 10, 1126891415), i = O(i, c, s, u, l[p + 14], 15, -1416354905), u = O(u, i, c, s, l[p + 5], 21, -57434055), s = O(s, u, i, c, l[p + 12], 6, 1700485571), c = O(c, s, u, i, l[p + 3], 10, -1894986606), i = O(i, c, s, u, l[p + 10], 15, -1051523), u = O(u, i, c, s, l[p + 1], 21, -2054922799), s = O(s, u, i, c, l[p + 8], 6, 1873313359), c = O(c, s, u, i, l[p + 15], 10, -30611744), i = O(i, c, s, u, l[p + 6], 15, -1560198380), u = O(u, i, c, s, l[p + 13], 21, 1309151649), s = O(s, u, i, c, l[p + 4], 6, -145523070), c = O(c, s, u, i, l[p + 11], 10, -1120210379), i = O(i, c, s, u, l[p + 2], 15, 718787259), u = O(u, i, c, s, l[p + 9], 21, -343485551), s = B(s, j), u = B(u, R), i = B(i, x), c = B(c, D);
          }
          return Array(s, u, i, c);
        }
        function h(l, g, s, u, i, c) {
          return B((g = B(B(g, l), B(u, c))) << i | g >>> 32 - i, s);
        }
        function E(l, g, s, u, i, c, p) {
          return h(g & s | ~g & u, l, g, i, c, p);
        }
        function L(l, g, s, u, i, c, p) {
          return h(g & u | s & ~u, l, g, i, c, p);
        }
        function _(l, g, s, u, i, c, p) {
          return h(g ^ s ^ u, l, g, i, c, p);
        }
        function O(l, g, s, u, i, c, p) {
          return h(s ^ (g | ~u), l, g, i, c, p);
        }
        function B(l, g) {
          var s = (65535 & l) + (65535 & g);
          return (l >> 16) + (g >> 16) + (s >> 16) << 16 | 65535 & s;
        }
        a.exports = function(l) {
          return y.hash(l, C, 16);
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(n, a, d) {
      (function(m, b, I, M, S, A, P, T, V) {
        a.exports = function(y) {
          for (var C, h = new Array(y), E = 0; E < y; E++)
            !(3 & E) && (C = 4294967296 * Math.random()), h[E] = C >>> ((3 & E) << 3) & 255;
          return h;
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { buffer: 3, lYpoI2: 11 }], 8: [function(n, a, d) {
      (function(m, b, I, M, S, A, P, T, V) {
        var y = n("./helpers");
        function C(L, _) {
          L[_ >> 5] |= 128 << 24 - _ % 32, L[15 + (_ + 64 >> 9 << 4)] = _;
          for (var O, B, l, g = Array(80), s = 1732584193, u = -271733879, i = -1732584194, c = 271733878, p = -1009589776, j = 0; j < L.length; j += 16) {
            for (var R = s, x = u, D = i, z = c, K = p, q = 0; q < 80; q++) {
              g[q] = q < 16 ? L[j + q] : E(g[q - 3] ^ g[q - 8] ^ g[q - 14] ^ g[q - 16], 1);
              var F = h(h(E(s, 5), (F = u, B = i, l = c, (O = q) < 20 ? F & B | ~F & l : !(O < 40) && O < 60 ? F & B | F & l | B & l : F ^ B ^ l)), h(h(p, g[q]), (O = q) < 20 ? 1518500249 : O < 40 ? 1859775393 : O < 60 ? -1894007588 : -899497514)), p = c, c = i, i = E(u, 30), u = s, s = F;
            }
            s = h(s, R), u = h(u, x), i = h(i, D), c = h(c, z), p = h(p, K);
          }
          return Array(s, u, i, c, p);
        }
        function h(L, _) {
          var O = (65535 & L) + (65535 & _);
          return (L >> 16) + (_ >> 16) + (O >> 16) << 16 | 65535 & O;
        }
        function E(L, _) {
          return L << _ | L >>> 32 - _;
        }
        a.exports = function(L) {
          return y.hash(L, C, 20, !0);
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(n, a, d) {
      (function(m, b, I, M, S, A, P, T, V) {
        function y(_, O) {
          var B = (65535 & _) + (65535 & O);
          return (_ >> 16) + (O >> 16) + (B >> 16) << 16 | 65535 & B;
        }
        function C(_, O) {
          var B, l = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), g = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), s = new Array(64);
          _[O >> 5] |= 128 << 24 - O % 32, _[15 + (O + 64 >> 9 << 4)] = O;
          for (var u, i, c = 0; c < _.length; c += 16) {
            for (var p = g[0], j = g[1], R = g[2], x = g[3], D = g[4], z = g[5], K = g[6], q = g[7], F = 0; F < 64; F++)
              s[F] = F < 16 ? _[F + c] : y(y(y((i = s[F - 2], E(i, 17) ^ E(i, 19) ^ L(i, 10)), s[F - 7]), (i = s[F - 15], E(i, 7) ^ E(i, 18) ^ L(i, 3))), s[F - 16]), B = y(y(y(y(q, E(i = D, 6) ^ E(i, 11) ^ E(i, 25)), D & z ^ ~D & K), l[F]), s[F]), u = y(E(u = p, 2) ^ E(u, 13) ^ E(u, 22), p & j ^ p & R ^ j & R), q = K, K = z, z = D, D = y(x, B), x = R, R = j, j = p, p = y(B, u);
            g[0] = y(p, g[0]), g[1] = y(j, g[1]), g[2] = y(R, g[2]), g[3] = y(x, g[3]), g[4] = y(D, g[4]), g[5] = y(z, g[5]), g[6] = y(K, g[6]), g[7] = y(q, g[7]);
          }
          return g;
        }
        var h = n("./helpers"), E = function(_, O) {
          return _ >>> O | _ << 32 - O;
        }, L = function(_, O) {
          return _ >>> O;
        };
        a.exports = function(_) {
          return h.hash(_, C, 32, !0);
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(n, a, d) {
      (function(m, b, I, M, S, A, P, T, V) {
        d.read = function(y, C, h, E, c) {
          var _, O, B = 8 * c - E - 1, l = (1 << B) - 1, g = l >> 1, s = -7, u = h ? c - 1 : 0, i = h ? -1 : 1, c = y[C + u];
          for (u += i, _ = c & (1 << -s) - 1, c >>= -s, s += B; 0 < s; _ = 256 * _ + y[C + u], u += i, s -= 8)
            ;
          for (O = _ & (1 << -s) - 1, _ >>= -s, s += E; 0 < s; O = 256 * O + y[C + u], u += i, s -= 8)
            ;
          if (_ === 0)
            _ = 1 - g;
          else {
            if (_ === l)
              return O ? NaN : 1 / 0 * (c ? -1 : 1);
            O += Math.pow(2, E), _ -= g;
          }
          return (c ? -1 : 1) * O * Math.pow(2, _ - E);
        }, d.write = function(y, C, h, E, L, p) {
          var O, B, l = 8 * p - L - 1, g = (1 << l) - 1, s = g >> 1, u = L === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, i = E ? 0 : p - 1, c = E ? 1 : -1, p = C < 0 || C === 0 && 1 / C < 0 ? 1 : 0;
          for (C = Math.abs(C), isNaN(C) || C === 1 / 0 ? (B = isNaN(C) ? 1 : 0, O = g) : (O = Math.floor(Math.log(C) / Math.LN2), C * (E = Math.pow(2, -O)) < 1 && (O--, E *= 2), 2 <= (C += 1 <= O + s ? u / E : u * Math.pow(2, 1 - s)) * E && (O++, E /= 2), g <= O + s ? (B = 0, O = g) : 1 <= O + s ? (B = (C * E - 1) * Math.pow(2, L), O += s) : (B = C * Math.pow(2, s - 1) * Math.pow(2, L), O = 0)); 8 <= L; y[h + i] = 255 & B, i += c, B /= 256, L -= 8)
            ;
          for (O = O << L | B, l += L; 0 < l; y[h + i] = 255 & O, i += c, O /= 256, l -= 8)
            ;
          y[h + i - c] |= 128 * p;
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
    }, { buffer: 3, lYpoI2: 11 }], 11: [function(n, a, d) {
      (function(m, b, I, M, S, A, P, T, V) {
        var y, C, h;
        function E() {
        }
        (m = a.exports = {}).nextTick = (C = typeof window < "u" && window.setImmediate, h = typeof window < "u" && window.postMessage && window.addEventListener, C ? function(L) {
          return window.setImmediate(L);
        } : h ? (y = [], window.addEventListener("message", function(L) {
          var _ = L.source;
          _ !== window && _ !== null || L.data !== "process-tick" || (L.stopPropagation(), 0 < y.length && y.shift()());
        }, !0), function(L) {
          y.push(L), window.postMessage("process-tick", "*");
        }) : function(L) {
          setTimeout(L, 0);
        }), m.title = "browser", m.browser = !0, m.env = {}, m.argv = [], m.on = E, m.addListener = E, m.once = E, m.off = E, m.removeListener = E, m.removeAllListeners = E, m.emit = E, m.binding = function(L) {
          throw new Error("process.binding is not supported");
        }, m.cwd = function() {
          return "/";
        }, m.chdir = function(L) {
          throw new Error("process.chdir is not supported");
        };
      }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
    }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
  });
})(Xt);
var $t = Xt.exports, it;
(function(o) {
  o.V0_3 = "0.3", o.V0_4 = "0.4", o.V0_5 = "0.5", o.V0_6 = "0.6";
})(it || (it = {}));
var st;
(function(o) {
  o.V0_2 = "0.2", o.V0_3 = "0.3";
})(st || (st = {}));
const Ft = Object.keys(it), Le = it.V0_6, zt = Object.keys(st), pt = st.V0_3;
var N;
(function(o) {
  o.Inputs = "inputs", o.Outputs = "outputs", o.State = "state", o.Definition = "definition", o.DefinitionUpdateRequest = "definitionupdaterequest", o.Error = "error", o.UrlHashUpdate = "urlhashupdate", o.Message = "Message";
})(N || (N = {}));
var X;
(function(o) {
  o.InputsUpdate = "InputsUpdate", o.OutputsUpdate = "OutputsUpdate", o.SetupIframeClientRequest = "SetupIframeClientRequest", o.SetupIframeServerResponseAck = "SetupIframeServerResponseAck", o.PluginRequest = "SetupIframeServerPluginRequestResponseAck", o.HashParamsUpdate = "HashParamsUpdate";
})(X || (X = {}));
var at;
(function(o) {
  o.InputsUpdate = "InputsUpdate", o.MessageAck = "MessageAck", o.SetupIframeServerResponse = "SetupIframeServerResponse";
})(at || (at = {}));
var kt;
(function(o) {
  o.State = "metapage/state";
})(kt || (kt = {}));
const rt = "metapage/definition", ft = "metapage/state", Qt = zt[zt.length - 1], ae = Ft[Ft.length - 1];
var lt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", dt = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var _t = 0; _t < lt.length; _t++)
  dt[lt.charCodeAt(_t)] = _t;
var wt = function(o) {
  var t = new Uint8Array(o), n, a = t.length, d = "";
  for (n = 0; n < a; n += 3)
    d += lt[t[n] >> 2], d += lt[(t[n] & 3) << 4 | t[n + 1] >> 4], d += lt[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], d += lt[t[n + 2] & 63];
  return a % 3 === 2 ? d = d.substring(0, d.length - 1) + "=" : a % 3 === 1 && (d = d.substring(0, d.length - 2) + "=="), d;
}, vt = function(o) {
  var t = o.length * 0.75, n = o.length, a, d = 0, m, b, I, M;
  o[o.length - 1] === "=" && (t--, o[o.length - 2] === "=" && t--);
  var S = new ArrayBuffer(t), A = new Uint8Array(S);
  for (a = 0; a < n; a += 4)
    m = dt[o.charCodeAt(a)], b = dt[o.charCodeAt(a + 1)], I = dt[o.charCodeAt(a + 2)], M = dt[o.charCodeAt(a + 3)], A[d++] = m << 2 | b >> 4, A[d++] = (b & 15) << 4 | I >> 2, A[d++] = (I & 3) << 6 | M & 63;
  return S;
};
const Ot = async (o) => {
  for (const t of Object.keys(o)) {
    const n = await ue(o[t]);
    o[t] = n;
  }
  return o;
}, gt = async (o) => {
  for (const t of Object.keys(o)) {
    const n = await fe(o[t]);
    o[t] = n;
  }
  return o;
}, ue = async (o) => {
  if (o instanceof Int8Array || o instanceof Uint8Array || o instanceof Uint8ClampedArray || o instanceof Int16Array || o instanceof Uint16Array || o instanceof Int32Array || o instanceof Uint32Array || o instanceof Float32Array || o instanceof Float64Array) {
    const t = o, n = {
      _s: !0,
      _c: o.constructor.name,
      value: wt(t.buffer),
      byteLength: t.byteLength,
      byteOffset: t.byteOffset,
      size: t.byteLength
    };
    return Promise.resolve(n);
  } else if (o instanceof File) {
    const t = o, n = await t.arrayBuffer();
    return {
      _s: !0,
      _c: File.name,
      value: wt(n),
      name: t.name,
      fileType: t.type,
      lastModified: t.lastModified,
      size: n.byteLength
    };
  } else if (o instanceof Blob) {
    const t = o, n = await t.arrayBuffer();
    return {
      _s: !0,
      _c: Blob.name,
      value: wt(n),
      fileType: t.type,
      size: n.byteLength
    };
  } else if (o instanceof ArrayBuffer) {
    const t = o, n = {
      _s: !0,
      _c: ArrayBuffer.name,
      value: wt(t),
      size: t.byteLength
    };
    return Promise.resolve(n);
  }
  return Promise.resolve(o);
}, fe = (o) => {
  if (!(o && typeof o == "object" && o._s === !0))
    return o;
  const t = o, n = t._c;
  if (n === Blob.name) {
    const b = o;
    return new Blob([vt(t.value)], {
      type: b.fileType
    });
  } else if (n === File.name) {
    const b = o;
    return new File([vt(t.value)], b.name, {
      type: b.fileType,
      lastModified: b.lastModified
    });
  } else if (n === ArrayBuffer.name)
    return vt(t.value);
  const a = o, d = vt(a.value), m = a._c;
  try {
    return new globalThis[m](d);
  } catch {
  }
  return o;
};
var Zt = { exports: {} };
(function(o) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function a() {
  }
  Object.create && (a.prototype = /* @__PURE__ */ Object.create(null), new a().__proto__ || (n = !1));
  function d(M, S, A) {
    this.fn = M, this.context = S, this.once = A || !1;
  }
  function m(M, S, A, P, T) {
    if (typeof A != "function")
      throw new TypeError("The listener must be a function");
    var V = new d(A, P || M, T), y = n ? n + S : S;
    return M._events[y] ? M._events[y].fn ? M._events[y] = [M._events[y], V] : M._events[y].push(V) : (M._events[y] = V, M._eventsCount++), M;
  }
  function b(M, S) {
    --M._eventsCount === 0 ? M._events = new a() : delete M._events[S];
  }
  function I() {
    this._events = new a(), this._eventsCount = 0;
  }
  I.prototype.eventNames = function() {
    var S = [], A, P;
    if (this._eventsCount === 0)
      return S;
    for (P in A = this._events)
      t.call(A, P) && S.push(n ? P.slice(1) : P);
    return Object.getOwnPropertySymbols ? S.concat(Object.getOwnPropertySymbols(A)) : S;
  }, I.prototype.listeners = function(S) {
    var A = n ? n + S : S, P = this._events[A];
    if (!P)
      return [];
    if (P.fn)
      return [P.fn];
    for (var T = 0, V = P.length, y = new Array(V); T < V; T++)
      y[T] = P[T].fn;
    return y;
  }, I.prototype.listenerCount = function(S) {
    var A = n ? n + S : S, P = this._events[A];
    return P ? P.fn ? 1 : P.length : 0;
  }, I.prototype.emit = function(S, A, P, T, V, y) {
    var C = n ? n + S : S;
    if (!this._events[C])
      return !1;
    var h = this._events[C], E = arguments.length, L, _;
    if (h.fn) {
      switch (h.once && this.removeListener(S, h.fn, void 0, !0), E) {
        case 1:
          return h.fn.call(h.context), !0;
        case 2:
          return h.fn.call(h.context, A), !0;
        case 3:
          return h.fn.call(h.context, A, P), !0;
        case 4:
          return h.fn.call(h.context, A, P, T), !0;
        case 5:
          return h.fn.call(h.context, A, P, T, V), !0;
        case 6:
          return h.fn.call(h.context, A, P, T, V, y), !0;
      }
      for (_ = 1, L = new Array(E - 1); _ < E; _++)
        L[_ - 1] = arguments[_];
      h.fn.apply(h.context, L);
    } else {
      var O = h.length, B;
      for (_ = 0; _ < O; _++)
        switch (h[_].once && this.removeListener(S, h[_].fn, void 0, !0), E) {
          case 1:
            h[_].fn.call(h[_].context);
            break;
          case 2:
            h[_].fn.call(h[_].context, A);
            break;
          case 3:
            h[_].fn.call(h[_].context, A, P);
            break;
          case 4:
            h[_].fn.call(h[_].context, A, P, T);
            break;
          default:
            if (!L)
              for (B = 1, L = new Array(E - 1); B < E; B++)
                L[B - 1] = arguments[B];
            h[_].fn.apply(h[_].context, L);
        }
    }
    return !0;
  }, I.prototype.on = function(S, A, P) {
    return m(this, S, A, P, !1);
  }, I.prototype.once = function(S, A, P) {
    return m(this, S, A, P, !0);
  }, I.prototype.removeListener = function(S, A, P, T) {
    var V = n ? n + S : S;
    if (!this._events[V])
      return this;
    if (!A)
      return b(this, V), this;
    var y = this._events[V];
    if (y.fn)
      y.fn === A && (!T || y.once) && (!P || y.context === P) && b(this, V);
    else {
      for (var C = 0, h = [], E = y.length; C < E; C++)
        (y[C].fn !== A || T && !y[C].once || P && y[C].context !== P) && h.push(y[C]);
      h.length ? this._events[V] = h.length === 1 ? h[0] : h : b(this, V);
    }
    return this;
  }, I.prototype.removeAllListeners = function(S) {
    var A;
    return S ? (A = n ? n + S : S, this._events[A] && b(this, A)) : (this._events = new a(), this._eventsCount = 0), this;
  }, I.prototype.off = I.prototype.removeListener, I.prototype.addListener = I.prototype.on, I.prefixed = n, I.EventEmitter = I, o.exports = I;
})(Zt);
var Dt = Zt.exports;
function Mt(o, t) {
  const n = Et(o), a = Et(t), d = n.pop(), m = a.pop(), b = Pt(n, a);
  return b !== 0 ? b : d && m ? Pt(d.split("."), m.split(".")) : d || m ? d ? -1 : 1 : 0;
}
const he = (o) => typeof o == "string" && /^[v\d]/.test(o) && te.test(o), ct = (o, t, n) => {
  de(n);
  const a = Mt(o, t);
  return ee[n].includes(a);
}, le = (o, t) => {
  const n = t.match(/^([<>=~^]+)/), a = n ? n[1] : "=";
  if (a !== "^" && a !== "~")
    return ct(o, t, a);
  const [d, m, b] = Et(o), [I, M, S] = Et(t);
  return It(d, I) !== 0 ? !1 : a === "^" ? Pt([m, b], [M, S]) >= 0 : It(m, M) !== 0 ? !1 : It(b, S) >= 0;
};
Mt.validate = he;
Mt.compare = ct;
Mt.satisfies = le;
const te = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i, Et = (o) => {
  if (typeof o != "string")
    throw new TypeError("Invalid argument expected string");
  const t = o.match(te);
  if (!t)
    throw new Error(`Invalid argument not valid semver ('${o}' received)`);
  return t.shift(), t;
}, qt = (o) => o === "*" || o === "x" || o === "X", Jt = (o) => {
  const t = parseInt(o, 10);
  return isNaN(t) ? o : t;
}, ce = (o, t) => typeof o != typeof t ? [String(o), String(t)] : [o, t], It = (o, t) => {
  if (qt(o) || qt(t))
    return 0;
  const [n, a] = ce(Jt(o), Jt(t));
  return n > a ? 1 : n < a ? -1 : 0;
}, Pt = (o, t) => {
  for (let n = 0; n < Math.max(o.length, t.length); n++) {
    const a = It(o[n] || 0, t[n] || 0);
    if (a !== 0)
      return a;
  }
  return 0;
}, ee = {
  ">": [1],
  ">=": [0, 1],
  "=": [0],
  "<=": [-1, 0],
  "<": [-1]
}, Wt = Object.keys(ee), de = (o) => {
  if (typeof o != "string")
    throw new TypeError(
      `Invalid operator type, expected string but got ${typeof o}`
    );
  if (Wt.indexOf(o) === -1)
    throw new Error(
      `Invalid operator, expected one of ${Wt.join("|")}`
    );
};
var mt;
(function(o) {
  o.mp_debug = "mp_debug";
})(mt || (mt = {}));
const pe = () => {
  try {
    return window !== window.top;
  } catch {
    return !1;
  }
}, ne = {
  version: pt,
  metaframes: {}
};
class ge extends Dt.EventEmitter {
  constructor() {
    super(), this._definition = ne, this.getDefinition = this.getDefinition.bind(this);
  }
  error(t) {
    throw "Subclass should implement";
  }
  getDefinition() {
    return this._definition;
  }
}
const ie = (o) => {
  if (o === null)
    throw "Metapage definition cannot be null";
  if (typeof o == "string")
    try {
      o = JSON.parse(o);
    } catch {
      throw `Cannot parse into JSON:
${o}`;
    }
  if (!o.version)
    throw 'Missing "version" key in metapage definition';
  let t;
  switch (re(o.version)) {
    case st.V0_2: {
      t = ie(be(o));
      break;
    }
    case st.V0_3: {
      t = o;
      break;
    }
    default:
      console.warn(`Metapage definition version=${o.version} but we only know up to version ${pt}. Assuming the definition is compatible, but it's the future!`), t = o;
      break;
  }
  return t;
}, se = (o, t) => {
  if (o)
    switch (o.version) {
      case void 0:
      case it.V0_3:
      case it.V0_4:
        return se(me(o));
      case it.V0_5:
        return ye(o);
      case it.V0_6:
        return o;
      default:
        if (t && t.errorIfUnknownVersion)
          throw `Unsupported metaframe version. Please upgrade to a new version: npm i @metapages/metapage@latest
 ${JSON.stringify(o)}
${window.location.href}`;
        return console.error(`Unsupported metaframe version. Not throwing an error because you might not be able to upgrade. Please upgrade to a new version: npm i @metapages/metapage@latest
 ${JSON.stringify(o)}
${window.location.href}`), o;
    }
}, me = (o) => {
  const { version: t, inputs: n, outputs: a, allow: d, metadata: m, ...b } = o, I = m, { title: M, author: S, image: A, descriptionUrl: P, keywords: T, iconUrl: V, ...y } = I, C = {
    name: M,
    author: S,
    description: P,
    image: A,
    tags: T,
    ...y
  };
  return {
    version: it.V0_5,
    inputs: n,
    outputs: a,
    allow: d,
    metadata: C,
    ...b
  };
}, ye = (o) => {
  const { metadata: t, ...n } = o, a = {
    ...n,
    version: it.V0_6
  };
  if (t) {
    const { edit: d, ...m } = t, b = { ...m };
    if (a.metadata = b, d && !(b && b.operations && b.operations.edit))
      switch (b.operations || (b.operations = {}), d.type) {
        case "metapage":
          const I = d.value, M = {
            type: "metapage",
            metapage: I.definition,
            metaframe: I.key || "edit"
          };
          b.operations.edit = M;
          break;
        case "metaframe":
          const S = d.value, A = {
            type: "url",
            url: S.url,
            params: S.params ? S.params.map((P) => ({
              to: P.to,
              from: P.from,
              toType: P.toType === "path" ? void 0 : P.toType
            })) : void 0
          };
          b.operations.edit = A;
          break;
        default:
          throw `Unsupported edit type: ${d.type} in metadata for metaframe ${JSON.stringify(t)}`;
      }
  }
  return a;
}, be = (o) => (o.version = st.V0_3, o), St = (o, t) => {
  if (!t)
    return !1;
  let n = !1;
  return Object.keys(t).forEach((a) => {
    n = !0, t[a] === void 0 ? delete o[a] : o[a] = t[a];
  }), n;
}, re = (o) => {
  if (o === "latest")
    return pt;
  if (ct(o, "0.2", "<"))
    throw `Unknown version: ${o}`;
  return ct(o, "0.2", ">=") && ct(o, st.V0_3, "<") ? st.V0_2 : ct(o, "0.3", ">=") ? st.V0_3 : (console.log(`Could not match version=${o} to any known version, assuming ${pt}`), pt);
}, Ue = (o) => window.location.search ? new URLSearchParams(window.location.search).get(o) : null, ke = () => new URLSearchParams(window.location.search).has(mt.mp_debug), Ct = () => {
  const o = new URLSearchParams(window.location.search).get(mt.mp_debug);
  return o === "true" || o === "1";
}, _e = (o) => o.filter((n) => new URLSearchParams(window.location.search).has(n)).length > 0, Pe = (o = 8) => Bt(o), we = (o = 8) => Bt(o), Ce = (o = 8) => Bt(o), Yt = "abcdefghijklmnopqrstuvwxyz0123456789", Bt = (o = 8) => {
  for (var t = "", n = Yt.length, a = 0; a < o; a++)
    t += Yt.charAt(Math.floor(Math.random() * n));
  return t;
}, Rt = (o, t, n) => {
  t = t || "000", t && t.trim() == "" && (t = void 0);
  let a;
  if (typeof o == "string" ? a = o : typeof o == "number" ? a = o + "" : a = JSON.stringify(o, null, "  "), t && t.trim() != "") {
    var d = `color: #${t}`;
    n && (d = `${d}; background: #${n}`), a = `%c${a}`, window.console.log(a, d);
  } else
    window.console.log(a);
}, oe = (o) => Ie(ve(o)), ve = (o) => {
  var t = 0;
  for (let n = 0; n < o.length; n++)
    t = o.charCodeAt(n) + ((t << 5) - t);
  return t;
}, Ie = (o) => {
  var t = (o & 16777215).toString(16).toUpperCase();
  return "00000".substring(0, 6 - t.length) + t;
}, Ut = () => document.readyState == "complete" || document.readyState == "interactive", jt = async () => Ut() ? Promise.resolve() : new Promise((o) => {
  if (Ut()) {
    o();
    return;
  }
  let t = !1;
  window.addEventListener("load", () => {
    t || (t = !0, o());
  }), setTimeout(() => {
    !t && Ut() && (t = !0, o());
  }, 200);
});
class Ht extends Dt.EventEmitter {
  constructor(t, n, a, d, m, b = !1) {
    if (super(), this.inputs = {}, this.outputs = {}, this._disposables = [], this._rpcListeners = [], this._loaded = !1, this._onLoaded = [], this._sendInputsAfterRegistration = !1, this._plugin = !1, this._cachedEventInputsUpdate = {
      iframeId: void 0,
      inputs: void 0
    }, this._cachedEventOutputsUpdate = {
      iframeId: null,
      inputs: null
    }, !n.startsWith("http")) {
      for (; n.startsWith("/"); )
        n = n.substring(1);
      n = window.location.protocol + "//" + window.location.hostname + (window.location.port && window.location.port != "" ? ":" + window.location.port : "") + "/" + n;
    }
    this.url = n, this._metapage = t;
    var I = new URL(this.url);
    b && I.searchParams.set(mt.mp_debug, "true"), this.url = I.href, this.id = a, this._debug = b, this._parentId = d, this._color = oe(this.id), this._consoleBackgroundColor = m, this._iframe = document.createElement("iframe"), this._iframe.name = this.id;
    const M = this;
    this.iframe = new Promise((S) => {
      jt().then(async () => {
        if (M._iframe) {
          const A = await M.getDefinition();
          if (!M._iframe)
            return;
          A && A.allow && (M._iframe.allow = A.allow), M._iframe.src = this.url, S(M._iframe);
        }
      });
    }), this.ack = this.ack.bind(this), this.dispose = this.dispose.bind(this), this.getDefinition = this.getDefinition.bind(this), this.getDefinitionUrl = this.getDefinitionUrl.bind(this), this.setPlugin = this.setPlugin.bind(this), this.hasPermissionsDefinition = this.hasPermissionsDefinition.bind(this), this.hasPermissionsState = this.hasPermissionsState.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.onInput = this.onInput.bind(this), this.onInputs = this.onInputs.bind(this), this.onOutput = this.onOutput.bind(this), this.onOutputs = this.onOutputs.bind(this), this.register = this.register.bind(this), this.registered = this.registered.bind(this), this.sendInputs = this.sendInputs.bind(this), this.sendOrBufferPostMessage = this.sendOrBufferPostMessage.bind(this), this.sendRpc = this.sendRpc.bind(this), this.sendRpcInternal = this.sendRpcInternal.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setMetapage = this.setMetapage.bind(this), this.setOutput = this.setOutput.bind(this), this.setOutputs = this.setOutputs.bind(this), this.setPlugin = this.setPlugin.bind(this), this.addListenerReturnDisposer = this.addListenerReturnDisposer.bind(this), this.isDisposed = this.isDisposed.bind(this);
  }
  addListenerReturnDisposer(t, n) {
    return super.addListener(t, n), () => {
      super.removeListener(t, n);
    };
  }
  setPlugin() {
    if (this._loaded)
      throw "Cannot setPlugin after MetapageIFrameRpcClient already loaded";
    return this._plugin = !0, this;
  }
  setMetapage(t) {
    return this._metapage = t, this;
  }
  hasPermissionsState() {
    return this._definition !== void 0 && this._definition.inputs !== void 0 && this._definition.inputs[ft] !== void 0;
  }
  hasPermissionsDefinition() {
    return this._definition !== void 0 && this._definition.inputs !== void 0 && this._definition.inputs[rt] !== void 0;
  }
  getDefinitionUrl() {
    var t = new URL(this.url);
    return t.pathname = t.pathname + (t.pathname.endsWith("/") ? "metaframe.json" : "/metaframe.json"), t.href;
  }
  async getDefinition() {
    if (this._definition)
      return this._definition;
    var t = this.getDefinitionUrl();
    try {
      const n = await window.fetch(t);
      if (n.ok) {
        const a = await n.json(), d = se(a);
        return this._definition = d, this._definition;
      } else
        this.emit(N.Error, `Failed to fetch: ${t}
Status: ${n.status}
Status text: ${n.statusText}`);
    } catch (n) {
      this.emit(N.Error, `Failed to fetch or convert: ${t}
Error: ${n}`);
    }
  }
  setInput(t, n) {
    console.assert(!!t);
    var a = {};
    a[t] = n, this.setInputs(a);
  }
  setInputs(t) {
    if (this.log({ m: "MetapageIFrameRpcClient", inputs: t }), !St(this.inputs, t))
      return this;
    if (this._loaded || (this._sendInputsAfterRegistration = !0), this._iframe.parentNode && this._loaded && this.sendInputs(t), this.emit(N.Inputs, this.inputs), this._metapage.listenerCount(N.Inputs) > 0) {
      var n = {};
      n[this.id] = t, this._metapage.emit(N.Inputs, n);
    }
    return this;
  }
  setOutput(t, n) {
    console.assert(!!t);
    var a = {};
    a[t] = n, this.setOutputs(a);
  }
  setOutputs(t) {
    if (St(this.outputs, t) && (this.emit(N.Outputs, t), this._metapage.listenerCount(N.Outputs) > 0)) {
      var n = {};
      n[this.id] = this.outputs, this._metapage.emit(N.Outputs, n);
    }
  }
  onInputs(t) {
    return this.addListenerReturnDisposer(N.Inputs, t);
  }
  onInput(t, n) {
    var a = function(d) {
      d.hasOwnProperty(t) && n(d[t]);
    };
    return this.addListenerReturnDisposer(N.Inputs, a);
  }
  onOutputs(t) {
    return this.addListenerReturnDisposer(N.Outputs, t);
  }
  onOutput(t, n) {
    var a = function(d) {
      d.hasOwnProperty(t) && n(d[t]);
    };
    return this.addListenerReturnDisposer(N.Outputs, a);
  }
  isDisposed() {
    return this.inputs === void 0;
  }
  dispose() {
    for (super.removeAllListeners(); this._disposables && this._disposables.length > 0; ) {
      const t = this._disposables.pop();
      t && t();
    }
    this._rpcListeners = void 0, this.inputs = void 0, this.outputs = void 0, this._iframe && this._iframe.parentNode && this._iframe.parentNode.removeChild(this._iframe), this._iframe = void 0, this._bufferMessages = void 0, this._bufferTimeout && (window.clearInterval(this._bufferTimeout), this._bufferTimeout = void 0), this._metapage = void 0;
  }
  register() {
    var t = {
      iframeId: this.id,
      parentId: this._parentId,
      plugin: this._plugin,
      state: {
        inputs: this.inputs
      },
      version: Qt
    };
    this.sendRpcInternal(at.SetupIframeServerResponse, t);
  }
  registered(t) {
    if (this.log({ m: "MetapageIFrameRpcClient.registered", inputs: this.inputs }), !this._loaded) {
      if (!t)
        throw "Cannot register without a version";
      for (this.version = t, this._loaded = !0; this._onLoaded && this._onLoaded.length > 0; )
        this._onLoaded.pop()();
      this._sendInputsAfterRegistration && this.sendInputs(this.inputs);
    }
  }
  async sendInputs(t) {
    t = await Ot(t), this.sendRpc(at.InputsUpdate, {
      inputs: t,
      parentId: this._parentId
    });
  }
  sendRpc(t, n) {
    if (this?._iframe?.parentNode && this._loaded)
      this.sendRpcInternal(t, n);
    else {
      this?._metapage?.error("sending rpc later");
      const a = this;
      this?._onLoaded.push(() => {
        a.sendRpcInternal(t, n);
      });
    }
  }
  ack(t) {
    if (this.log("⚒ ⚒ ⚒ calling ack"), this._debug) {
      this.log("⚒ ⚒ ⚒ sending ack from client to frame");
      var n = {
        message: t
      };
      this.sendRpc(at.MessageAck, n);
    } else
      this.log("⚒ ⚒ ⚒ NOT sending ack from client to frame since not debug mode");
  }
  log(t) {
    this._debug && this.logInternal(t);
  }
  logInternal(t) {
    let n;
    typeof t == "string" ? n = t : typeof t == "string" ? n = t + "" : n = JSON.stringify(t), Rt(`Metapage[${this._parentId}] Metaframe[${this.id}] ${n}`, this._color, this._consoleBackgroundColor);
  }
  sendRpcInternal(t, n) {
    const a = {
      id: "_",
      iframeId: this.id,
      jsonrpc: "2.0",
      method: t,
      params: n,
      parentId: this._parentId
    };
    this._iframe ? this.sendOrBufferPostMessage(a) : this._metapage ? this._metapage.error(`Cannot send to child iframe messageJSON=${JSON.stringify(a).substring(0, 200)}`) : console.error(`Cannot send to child iframe messageJSON=${JSON.stringify(a).substring(0, 200)}`);
  }
  sendOrBufferPostMessage(t) {
    if (this._iframe && this._iframe.contentWindow)
      this._iframe.contentWindow.postMessage(t, this.url);
    else if (this._bufferMessages)
      this._bufferMessages.push(t);
    else {
      this._bufferMessages = [t];
      const n = this;
      this._bufferTimeout = window.setInterval(function() {
        n._iframe && n._iframe.contentWindow && (n._bufferMessages.forEach((a) => n._iframe.contentWindow.postMessage(a, n.url)), window.clearInterval(n._bufferTimeout), n._bufferTimeout = void 0, n._bufferMessages = void 0);
      }, 0);
    }
  }
}
var Gt;
(function(o) {
  o.all = "all", o.delta = "delta";
})(Gt || (Gt = {}));
const Kt = () => ({
  metaframes: {
    inputs: {},
    outputs: {}
  },
  plugins: {
    inputs: {},
    outputs: {}
  }
}), De = (o) => re(o), Ee = (o, t) => !t || t === "*" || o === t ? !0 : t.endsWith("*") ? o.startsWith(t.slice(0, -1)) : t.startsWith("*") ? o.endsWith(t.slice(1)) : !1, Se = "bcbcbc";
class tt extends ge {
  constructor(t) {
    super(), this._state = Kt(), this._metaframes = {}, this._plugins = {}, this._pluginOrder = [], this.debug = Ct(), this._internalReceivedMessageCounter = 0, this._cachedInputLookupMap = {}, this._inputMap = {}, this._id = t && t.id ? t.id : we(), this._consoleBackgroundColor = t && t.color ? t.color : Se, this.addPipe = this.addPipe.bind(this), this.dispose = this.dispose.bind(this), this.addMetaframe = this.addMetaframe.bind(this), this.addPlugin = this.addPlugin.bind(this), this.getInputsFromOutput = this.getInputsFromOutput.bind(this), this.getMetaframe = this.getMetaframe.bind(this), this.getMetaframeIds = this.getMetaframeIds.bind(this), this.getMetaframeOrPlugin = this.getMetaframeOrPlugin.bind(this), this.getMetaframes = this.getMetaframes.bind(this), this.getPlugin = this.getPlugin.bind(this), this.getPluginIds = this.getPluginIds.bind(this), this.getState = this.getState.bind(this), this.getStateMetaframes = this.getStateMetaframes.bind(this), this.isValidJSONRpcMessage = this.isValidJSONRpcMessage.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.metaframeIds = this.metaframeIds.bind(this), this.metaframes = this.metaframes.bind(this), this.onMessage = this.onMessage.bind(this), this.pluginIds = this.pluginIds.bind(this), this.plugins = this.plugins.bind(this), this.removeAll = this.removeAll.bind(this), this.removeMetaframe = this.removeMetaframe.bind(this), this.removePlugin = this.removePlugin.bind(this), this.setDebugFromUrlParams = this.setDebugFromUrlParams.bind(this), this.setDefinition = this.setDefinition.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setInputStateOnly = this.setInputStateOnly.bind(this), this.setMetaframeClientInputAndSentClientEvent = this.setMetaframeClientInputAndSentClientEvent.bind(this), this.setOutputStateOnly = this.setOutputStateOnly.bind(this), this.setState = this.setState.bind(this), this.isDisposed = this.isDisposed.bind(this), this.updatePluginsWithDefinition = this.updatePluginsWithDefinition.bind(this), this._emitDefinitionEvent = this._emitDefinitionEvent.bind(this), jt().then(() => {
      this.isDisposed() || (window.addEventListener("message", this.onMessage), this.log("Initialized"));
    });
  }
  static from(t, n) {
    if (t == null)
      throw "Metapage definition cannot be null";
    if (typeof t == "string")
      try {
        t = JSON.parse(t);
      } catch {
        throw "Cannot parse into JSON:\n${metaPageDef}";
      }
    var a = new tt();
    return a.setDefinition(t);
  }
  isDisposed() {
    return this._metaframes === void 0;
  }
  addListenerReturnDisposer(t, n) {
    return super.addListener(t, n), () => {
      super.removeListener(t, n);
    };
  }
  setDebugFromUrlParams() {
    return this.debug = _e(["MP_DEBUG", "DEBUG", "debug", "mp_debug"]), this;
  }
  getState() {
    return this._state;
  }
  setState(t) {
    this._state = t, this.getMetaframeIds().forEach((n) => {
      this.getMetaframe(n).setInputs(this._state.metaframes.inputs[n]), this.getMetaframe(n).setOutputs(this._state.metaframes.outputs[n]);
    }), this.getPluginIds().forEach((n) => {
      this.getPlugin(n).setInputs(this._state.plugins.inputs[n]), this.getPlugin(n).setOutputs(this._state.plugins.outputs[n]);
    }), this.emit(N.State, this._state);
  }
  getStateMetaframes() {
    return this._state.metaframes;
  }
  getDefinition() {
    return this._definition;
  }
  setDefinition(t, n) {
    if (!t.version)
      throw "Metapage definition must have a version";
    const a = ie(t);
    a.metaframes && Object.keys(a.metaframes).forEach((m) => {
      if (a.plugins && a.plugins.includes(m))
        throw this.emitErrorMessage(`Plugin with url=${m} matches metaframe. Metaframe ids and plugin urls are not allowed to collide`), `Plugin with url=${m} matches metaframe. Metaframe ids and plugin urls are not allowed to collide`;
      var b = a.metaframes[m];
      if (typeof b != "object")
        throw this.emitErrorMessage(`Metaframe "${m}" is not an object`), `Metaframe "${m}" is not an object`;
      if (!b.url)
        throw this.emitErrorMessage(`Metaframe "${m}" missing field: url`), `Metaframe "${m}" missing field: url`;
    });
    const d = this._definition;
    return this._definition = a, Object.keys(this._metaframes).forEach((m) => {
      (!a.metaframes || !a.metaframes[m]) && this.removeMetaframe(m);
    }), Object.keys(this._plugins).forEach((m) => {
      a.plugins && !a.plugins.includes(m) && this.removePlugin(m);
    }), this._pluginOrder = a.plugins ? a.plugins : [], n && (this._state = n), a.metaframes && Object.keys(a.metaframes).forEach((m) => {
      if (!this._metaframes.hasOwnProperty(m)) {
        const b = a.metaframes[m];
        this.addMetaframe(m, b);
      }
    }), a.plugins && a.plugins.forEach((m) => {
      this._plugins.hasOwnProperty(m) || this.addPlugin(m);
    }), d !== ne && window.setTimeout(() => {
      !this.isDisposed() && a === this._definition && (this._emitDefinitionEvent(), n && this.emit(N.State, this._state));
    }, 0), this;
  }
  _emitDefinitionEvent() {
    const t = {
      definition: this._definition,
      metaframes: this._metaframes,
      plugins: this._plugins
    };
    this.emit(N.Definition, t);
  }
  addPipe(t, n) {
    this._inputMap[t] || (this._inputMap[t] = []), this._inputMap[t].push(n);
  }
  removeMetaframe(t) {
    this._metaframes[t] && (this._metaframes[t].dispose(), delete this._metaframes[t], delete this._state.metaframes.inputs[t], delete this._state.metaframes.outputs[t], delete this._inputMap[t], Object.keys(this._inputMap).forEach((n) => {
      const a = this._inputMap[n];
      let d = 0;
      for (; d <= a.length; )
        a[d] && a[d].metaframe === t ? a.splice(d, 1) : d++;
    }), this._cachedInputLookupMap = {});
  }
  removePlugin(t) {
    this._plugins[t] && (this._plugins[t].dispose(), delete this._plugins[t], delete this._state.plugins.inputs[t], delete this._state.plugins.outputs[t]);
  }
  removeAll() {
    Object.keys(this._metaframes).forEach((t) => this._metaframes[t].dispose()), Object.keys(this._plugins).forEach((t) => this._plugins[t].dispose()), this._metaframes = {}, this._plugins = {}, this._state = Kt(), this._inputMap = {}, this._cachedInputLookupMap = {};
  }
  metaframes() {
    return this.getMetaframes();
  }
  metaframeIds() {
    return this.getMetaframeIds();
  }
  getMetaframeIds() {
    return Object.keys(this._metaframes);
  }
  getMetaframes() {
    return Object.assign({}, this._metaframes);
  }
  plugins() {
    return Object.assign({}, this._plugins);
  }
  pluginIds() {
    return this.getPluginIds();
  }
  getPluginIds() {
    return this._pluginOrder.slice(0);
  }
  getMetaframe(t) {
    return this?._metaframes[t];
  }
  getPlugin(t) {
    return this?._plugins?.[t];
  }
  addMetaframe(t, n) {
    if (!t)
      throw "addMetaframe missing metaframeId";
    if (!n)
      throw "addMetaframe missing definition";
    if (this._metaframes[t])
      throw this.emitErrorMessage(`Existing metaframe for id=${t}`), `Existing metaframe for id=${t}`;
    if (!n.url)
      throw this.emitErrorMessage(`Metaframe definition missing url id=${t}`), `Metaframe definition missing url id=${t}`;
    var a = new Ht(this, n.url, t, this._id, this._consoleBackgroundColor, this.debug).setMetapage(this);
    return this._metaframes[t] = a, a.addListener(N.Error, (d) => {
      this.emit(N.Error, {
        metaframeId: a.id,
        metaframeUrl: a.url,
        error: d
      });
    }), n.inputs && n.inputs.forEach((d) => this.addPipe(t, d)), a.setInputs(this._state.metaframes.inputs[t]), a;
  }
  addPlugin(t) {
    if (!t)
      throw "Plugin missing url";
    const n = new Ht(this, t, t, this._id, this._consoleBackgroundColor, this.debug).setInputs(this._state.plugins.inputs[t]).setMetapage(this).setPlugin();
    return Oe(this, n), this._plugins[t] = n, n;
  }
  dispose() {
    this.log("disposing"), super.removeAllListeners(), window.removeEventListener("message", this.onMessage), this._metaframes && Object.keys(this._metaframes).forEach((t) => this._metaframes[t].dispose()), this._plugins && Object.keys(this._plugins).forEach((t) => this._plugins[t].dispose()), this._id = void 0, this._metaframes = void 0, this._plugins = void 0, this._state = void 0, this._cachedInputLookupMap = void 0, this._inputMap = void 0;
  }
  log(t, n, a) {
    this.debug && this.logInternal(t, n, a);
  }
  error(t) {
    this.logInternal(t, "f00", this._consoleBackgroundColor), this.emitErrorMessage(`${t}`);
  }
  emitErrorMessage(t) {
    this.emit(N.Error, t);
  }
  getInputsFromOutput(t, n) {
    if (this._cachedInputLookupMap[t] || (this._cachedInputLookupMap[t] = {}), !this._cachedInputLookupMap[t][n]) {
      var a = [];
      this._cachedInputLookupMap[t][n] = a, Object.keys(this._inputMap).forEach((d) => {
        d !== t && this._inputMap[d].forEach((m) => {
          if (m.metaframe == t && Ee(n, m.source)) {
            var b = m.target;
            (!m.target || m.target.startsWith("*") || m.target === "") && (b = n), a.push({ metaframe: d, pipe: b });
          }
        });
      });
    }
    return this._cachedInputLookupMap[t][n];
  }
  isValidJSONRpcMessage(t) {
    if (t.jsonrpc !== "2.0")
      return !1;
    switch (t.method) {
      case X.SetupIframeClientRequest:
        return !0;
      default:
        var a = t.iframeId;
        return !(a && !(t.parentId === this._id && (this._metaframes[a] || this._plugins[a])));
    }
  }
  setInput(t, n, a) {
    this.setInputStateOnly(t, n, a), this.setMetaframeClientInputAndSentClientEvent(t, n, a), this.emit(N.State, this._state), this.emit(N.Inputs, this._state);
  }
  setMetaframeClientInputAndSentClientEvent(t, n, a) {
    if (typeof t == "object") {
      if (n || a)
        throw "bad arguments, see API docs";
      const d = t;
      Object.keys(d).forEach((m) => {
        var b = m, I = d[b];
        if (typeof I != "object")
          throw "bad arguments, see API docs";
        var M = this._metaframes[b];
        M ? M.setInputs(I) : this.error("No iframe id=$metaframeId");
      });
    } else if (typeof t == "string") {
      const d = this._metaframes[t];
      if (d == null && this.error(`No iframe id=${t}`), typeof n == "string")
        d.setInput(n, a);
      else if (typeof n == "object")
        d.setInputs(n);
      else
        throw "bad arguments, see API docs";
    } else
      throw "bad arguments, see API docs";
  }
  setInputs(t, n, a) {
    this.setInput(t, n, a);
  }
  setOutputStateOnly(t, n, a) {
    this._setStateOnly(!1, t, n, a);
  }
  setInputStateOnly(t, n, a) {
    this._setStateOnly(!0, t, n, a);
  }
  _setStateOnly(t, n, a, d) {
    if (typeof n == "object") {
      if (a || d)
        throw "If first argument is an object, subsequent args should be undefined";
      const m = n;
      Object.keys(m).forEach((b) => {
        var I = m[b];
        if (typeof I != "object")
          throw "Object values must be objects";
        const M = this._metaframes.hasOwnProperty(b);
        if (!M && !this._plugins.hasOwnProperty(b))
          throw "No metaframe or plugin: ${metaframeId}";
        const S = M ? t ? this._state.metaframes.inputs : this._state.metaframes.outputs : t ? this._state.plugins.inputs : this._state.plugins.outputs;
        S[b] = S[b] ? S[b] : {}, Object.keys(I).forEach((A) => {
          I[A] === void 0 ? delete S[b][A] : S[b][A] = I[A];
        });
      });
    } else if (typeof n == "string") {
      const m = n, b = this._metaframes.hasOwnProperty(m);
      if (!b && !this._plugins.hasOwnProperty(m))
        throw `No metaframe or plugin: ${m}`;
      const I = b ? t ? this._state.metaframes.inputs : this._state.metaframes.outputs : t ? this._state.plugins.inputs : this._state.plugins.outputs;
      if (typeof a == "string") {
        I[m] = I[m] ? I[m] : {};
        const M = a;
        d === void 0 ? delete I[m][M] : I[m][M] = d;
      } else if (typeof a == "object") {
        I[m] = I[m] ? I[m] : {};
        const M = a;
        Object.keys(M).forEach((S) => {
          M[S] === void 0 ? delete I[m][S] : I[m][S] = M[S];
        });
      } else
        throw "Second argument must be a string or an object";
    } else
      throw "First argument must be a string or an object";
  }
  getMetaframeOrPlugin(t) {
    var n = this._metaframes[t];
    return n || (n = this._plugins[t]), n;
  }
  onMessage(t) {
    if (typeof t.data == "object") {
      const b = t.data;
      if (!this.isValidJSONRpcMessage(b))
        return;
      var n = b.method;
      const I = b.iframeId;
      if (!I)
        return;
      const M = this.getMetaframeOrPlugin(I), S = this._plugins[I];
      switch (b._messageCount = ++this._internalReceivedMessageCounter, this.debug && this.log(`processing ${JSON.stringify(b, null, "  ").substr(0, 500)}`), n) {
        case X.SetupIframeClientRequest:
          M && M.register();
          break;
        case X.SetupIframeServerResponseAck:
          if (M) {
            const P = b.params;
            M.registered(P.version);
          }
          break;
        case X.OutputsUpdate:
          const A = b.params;
          if (this._metaframes[I]) {
            var a = this._metaframes[I];
            this.setOutputStateOnly(I, A), a.setOutputs(A), this.emit(N.State, this._state);
            var d = !1;
            const P = Object.keys(A), T = {};
            P.forEach((V, y) => {
              const C = this.getInputsFromOutput(I, V);
              C.length > 0 && C.forEach((h) => {
                T[h.metaframe] || (T[h.metaframe] = {}), T[h.metaframe][h.pipe] = A[V], this.setInputStateOnly(h.metaframe, h.pipe, A[V]), d = !0;
              });
            }), Object.keys(T).forEach((V) => {
              this._metaframes[V].setInputs(T[V]);
            }), d && this.emit(N.State, this._state), this.debug && a.ack({ jsonrpc: b, state: this._state });
          } else if (this._plugins[I]) {
            const P = !A[ft] && !A[rt];
            P && this.setOutputStateOnly(I, A), this._plugins[I].setOutputs(A), P && this.emit(N.State, this._state), this.debug && this._plugins[I].ack({
              jsonrpc: b,
              state: this._state
            });
          } else
            this.error("missing metaframe/plugin=$metaframeId");
          break;
        case X.InputsUpdate:
          var m = b.params;
          if (this.debug && this.log(`inputs ${JSON.stringify(m)} from ${I}`), this._metaframes[I])
            this.setInputStateOnly(I, m), this._metaframes[I].setInputs(m), this.emit(N.State, this._state), this.debug && this._metaframes[I].ack({
              jsonrpc: b,
              state: this._state
            });
          else if (this._plugins[I]) {
            const P = !m[ft] && !m[rt];
            P && this.setInputStateOnly(I, m), this._plugins[I].setInputs(m), P && this.emit(N.State, this._state), this.debug && this._plugins[I].ack({
              jsonrpc: b,
              state: this._state
            });
          } else
            console.error(`InputsUpdate failed no metaframe or plugin id: "${I}"`), this.error(`InputsUpdate failed no metaframe or plugin id: "${I}"`);
          break;
        case X.PluginRequest:
          S && M && M.hasPermissionsState() && (M.setInput(ft, this._state), this.debug && M.ack({ jsonrpc: b, state: this._state }));
          break;
        case X.HashParamsUpdate:
          if (!S && M) {
            const P = b.params, T = new URL(M.url);
            T.hash = P.hash, M.url = T.href, this._definition.metaframes[P.metaframe].url = T.href, this._emitDefinitionEvent();
          }
          break;
        default:
          this.debug && this.log(`Unknown RPC method: "${n}"`);
      }
      this.emit(N.Message, b);
    }
  }
  updatePluginsWithDefinition() {
    this.getDefinition(), Object.values(this._plugins).forEach((t) => {
      t.hasPermissionsDefinition() && Me(t);
    });
  }
  logInternal(t, n, a) {
    a = a || this._consoleBackgroundColor;
    let d;
    typeof t == "string" ? d = t : typeof t == "number" ? d = t + "" : d = JSON.stringify(t), d = this._id ? `Metapage[${this._id}] ${d}` : d, Rt(d, n, a);
  }
}
tt.version = Qt;
tt.DEFINITION = N.Definition;
tt.DEFINITION_UPDATE_REQUEST = N.DefinitionUpdateRequest;
tt.ERROR = N.Error;
tt.INPUTS = N.Inputs;
tt.MESSAGE = N.Message;
tt.OUTPUTS = N.Outputs;
tt.STATE = N.State;
tt.deserializeInputs = gt;
tt.serializeInputs = Ot;
const Oe = async (o, t) => {
  try {
    const d = await t.getDefinition();
    if (!d)
      throw `${t.url}`;
    if (t.isDisposed())
      return;
    if (t.hasPermissionsDefinition()) {
      var n = o.addListenerReturnDisposer(N.Definition, (m) => {
        t.setInput(rt, m.definition);
      });
      t._disposables.push(n);
      var a = o.getDefinition();
      if (a && (t.setInput(rt, a), d.outputs)) {
        var n = t.onOutput(rt, (b) => {
          $t.sha1(b) !== $t.sha1(a) && o.emit(N.DefinitionUpdateRequest, b);
        });
        t._disposables.push(n);
      }
    }
    if (t.hasPermissionsState() && d.outputs) {
      var n = t.onOutput(ft, (b) => {
        o.setState(b);
      });
      t._disposables.push(n);
    }
  } catch (d) {
    console.error(d), o.emit(N.Error, `Failed to get plugin definition from "${t.getDefinitionUrl()}", error=${d}`);
  }
}, Me = (o) => {
  const t = o._metapage.getDefinition();
  o.setInput(rt, t);
};
var ut;
(function(o) {
  o.WaitingForPageLoad = "WaitingForPageLoad", o.SentSetupIframeClientRequest = "SentSetupIframeClientRequest", o.Ready = "Ready";
})(ut || (ut = {}));
var G;
(function(o) {
  o.Connected = "connected", o.Error = "error", o.Input = "input", o.Inputs = "inputs", o.Message = "message";
})(G || (G = {}));
class nt extends Dt.EventEmitter {
  constructor(t) {
    if (super(), this._inputPipeValues = {}, this._outputPipeValues = {}, this._state = ut.WaitingForPageLoad, this._messageSendCount = 0, this.debug = Ct(), this.isInputOutputBlobSerialization = !0, this.id = window.name, this.debug = Ct(), this._isIframe = pe(), this.addListener = this.addListener.bind(this), this.dispose = this.dispose.bind(this), this.error = this.error.bind(this), this.getInput = this.getInput.bind(this), this.getInputs = this.getInputs.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.onInput = this.onInput.bind(this), this.onInputs = this.onInputs.bind(this), this.onMessage = this.onMessage.bind(this), this.sendRpc = this.sendRpc.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setInternalInputsAndNotify = this.setInternalInputsAndNotify.bind(this), this.setOutput = this.setOutput.bind(this), this.setOutputs = this.setOutputs.bind(this), this.warn = this.warn.bind(this), this._resolveSetupIframeServerResponse = this._resolveSetupIframeServerResponse.bind(this), this.addListenerReturnDisposer = this.addListenerReturnDisposer.bind(this), this.connected = this.connected.bind(this), this.disableNotifyOnHashUrlChange = this.disableNotifyOnHashUrlChange.bind(this), this._onHashUrlChange = this._onHashUrlChange.bind(this), !this._isIframe) {
      this.log("Not an iframe, metaframe code disabled");
      return;
    }
    const n = this;
    jt().then(() => {
      this.log("pageLoaded"), window.addEventListener("message", this.onMessage), n.sendRpc(X.SetupIframeClientRequest, {
        version: nt.version
      }), n._state = ut.SentSetupIframeClientRequest;
    }), t && t.disableHashChangeEvent || window.addEventListener("hashchange", this._onHashUrlChange);
  }
  _resolveSetupIframeServerResponse(t) {
    if (this._state === ut.WaitingForPageLoad)
      throw "Got message but page has not finished loading, we should never get in this state";
    (async () => this._parentId ? this.log("Got JsonRpcMethods.SetupIframeServerResponse but already resolved") : (this._parentVersion = t.version, this.color = oe(this.id), this._parentId = t.parentId, this.log(`metapage[${this._parentId}](v${this._parentVersion ? this._parentVersion : "unknown"}) registered`), t.state && t.state.inputs && (this.isInputOutputBlobSerialization ? this._inputPipeValues = await gt(t.state.inputs) : this._inputPipeValues = t.state.inputs), this._state = ut.Ready, this.sendRpc(X.SetupIframeServerResponseAck, {
      version: nt.version
    }), this._inputPipeValues && Object.keys(this._inputPipeValues).length > 0 && (this.emit(G.Inputs, this._inputPipeValues), Object.keys(this._inputPipeValues).forEach((n) => this.emit(G.Input, n, this._inputPipeValues[n]))), this.emit(G.Inputs, this._inputPipeValues), t.plugin && (this.plugin = new Ae(this)), this.emit(G.Connected)))();
  }
  async connected() {
    if (this._state !== ut.Ready)
      return new Promise((t, n) => {
        let a;
        a = this.addListenerReturnDisposer(G.Connected, () => {
          t(), a();
        });
      });
  }
  addListenerReturnDisposer(t, n) {
    return super.addListener(t, n), () => {
      super.removeListener(t, n);
    };
  }
  log(t, n, a) {
    this.debug && this.logInternal(t, n || this.color);
  }
  warn(t) {
    this.debug && this.logInternal(t, "000", this.color);
  }
  error(t) {
    this.logInternal(t, this.color, "f00");
  }
  logInternal(t, n, a) {
    let d;
    typeof t == "string" ? d = t : typeof t == "number" ? d = t + "" : d = JSON.stringify(t), n = n && n + "", d = (this.id ? `Metaframe[${this.id}] ` : "") + `${d}`, Rt(d, n, a);
  }
  dispose() {
    super.removeAllListeners(), window.removeEventListener("message", this.onMessage), this.disableNotifyOnHashUrlChange(), this._inputPipeValues = void 0, this._outputPipeValues = void 0;
  }
  addListener(t, n) {
    return super.addListener(t, n), t === G.Inputs && window.setTimeout(() => {
      this._inputPipeValues && n(this._inputPipeValues);
    }, 0), this;
  }
  onInput(t, n) {
    return this.addListenerReturnDisposer(G.Input, (a, d) => {
      t === a && n(d);
    });
  }
  onInputs(t) {
    return this.addListenerReturnDisposer(G.Inputs, t);
  }
  setInput(t, n) {
    var a = {};
    a[t] = n, this.setInputs(a);
  }
  async setInputs(t) {
    this.isInputOutputBlobSerialization && (t = await gt(t)), this.sendRpc(X.InputsUpdate, t);
  }
  async setInternalInputsAndNotify(t) {
    this.isInputOutputBlobSerialization && (t = await gt(t)), St(this._inputPipeValues, t) && (Object.keys(t).forEach((n) => this.emit(G.Input, n, t[n])), this.emit(G.Inputs, t));
  }
  getInput(t) {
    return console.assert(!!t), this._inputPipeValues[t];
  }
  getInputs() {
    return this._inputPipeValues;
  }
  setOutput(t, n) {
    console.assert(!!t);
    var a = {};
    a[t] = n, this.setOutputs(a);
  }
  async setOutputs(t) {
    this.isInputOutputBlobSerialization && (t = await Ot(t)), St(this._outputPipeValues, t) && this.sendRpc(X.OutputsUpdate, t);
  }
  disableNotifyOnHashUrlChange() {
    window.removeEventListener("hashchange", this._onHashUrlChange);
  }
  _onHashUrlChange(t) {
    const n = {
      hash: window.location.hash,
      metaframe: this.id
    };
    this.sendRpc(X.HashParamsUpdate, n);
  }
  sendRpc(t, n) {
    if (this._isIframe) {
      const a = {
        jsonrpc: "2.0",
        id: ++this._messageSendCount,
        method: t,
        params: n,
        iframeId: this.id,
        parentId: this._parentId
      };
      window.parent && window.parent.postMessage(a, "*");
    } else
      this.log("Cannot send JSON-RPC window message: there is no window.parent which means we are not an iframe");
  }
  onMessage(t) {
    if (typeof t.data == "object") {
      let a = t.data;
      if (a.jsonrpc === "2.0") {
        var n = a.method;
        if (!(n == at.SetupIframeServerResponse || a.parentId == this._parentId && a.iframeId == this.id)) {
          this.log(`window.message: received message but jsonrpc.parentId=${a.parentId} _parentId=${this._parentId} jsonrpc.iframeId=${a.iframeId} id=${this.id}`);
          return;
        }
        switch (n) {
          case at.SetupIframeServerResponse:
            this._resolveSetupIframeServerResponse(a.params);
            break;
          case at.InputsUpdate:
            if (this._state !== ut.Ready)
              throw "Got InputsUpdate but metaframe is not MetaframeLoadingState.Ready";
            this.setInternalInputsAndNotify(a.params.inputs);
            break;
          case at.MessageAck:
            this.debug && this.log(`ACK: ${JSON.stringify(a)}`);
            break;
          default:
            this.debug && this.log(`window.message: unknown JSON-RPC method: ${JSON.stringify(a)}`);
            break;
        }
        this.emit(G.Message, a);
      }
    }
  }
}
nt.version = ae;
nt.ERROR = G.Error;
nt.CONNECTED = G.Connected;
nt.INPUT = G.Input;
nt.INPUTS = G.Inputs;
nt.MESSAGE = G.Message;
nt.deserializeInputs = gt;
nt.serializeInputs = Ot;
class Ae {
  constructor(t) {
    this._metaframe = t, this.requestState = this.requestState.bind(this), this.onState = this.onState.bind(this), this.getState = this.getState.bind(this), this.setState = this.setState.bind(this), this.onDefinition = this.onDefinition.bind(this), this.getDefinition = this.getDefinition.bind(this), this.setDefinition = this.setDefinition.bind(this);
  }
  requestState() {
    var t = {
      method: kt.State
    };
    this._metaframe.sendRpc(X.PluginRequest, t);
  }
  onState(t) {
    const n = this._metaframe.onInput(ft, t);
    return this.getState() && t(this.getState()), n;
  }
  getState() {
    return this._metaframe.getInput(ft);
  }
  setState(t) {
    this._metaframe.setOutput(ft, t);
  }
  onDefinition(t) {
    var n = this._metaframe.onInput(rt, t);
    return this.getDefinition() && t(this.getDefinition()), n;
  }
  setDefinition(t) {
    this._metaframe.setOutput(rt, t);
  }
  getDefinition() {
    return this._metaframe.getInput(rt);
  }
}
export {
  kt as ApiPayloadPluginRequestMethod,
  ne as INITIAL_NULL_METAPAGE_DEFINITION,
  X as JsonRpcMethodsFromChild,
  at as JsonRpcMethodsFromParent,
  nt as Metaframe,
  G as MetaframeEvents,
  ut as MetaframeLoadingState,
  Ae as MetaframePlugin,
  Le as MetaframeVersionCurrent,
  Ft as MetaframeVersionsAll,
  tt as Metapage,
  Gt as MetapageEventStateType,
  N as MetapageEvents,
  mt as MetapageHashParams,
  Ht as MetapageIFrameRpcClient,
  ge as MetapageShared,
  pt as MetapageVersionCurrent,
  zt as MetapageVersionsAll,
  it as VersionsMetaframe,
  st as VersionsMetapage,
  se as convertMetaframeJsonToCurrentVersion,
  ie as convertMetapageDefinitionToCurrentVersion,
  gt as deserializeInputs,
  _e as existsAnyUrlParam,
  Bt as generateId,
  Pe as generateMetaframeId,
  we as generateMetapageId,
  Ce as generateNonce,
  De as getLibraryVersionMatching,
  re as getMatchingVersion,
  Ue as getUrlParam,
  ke as getUrlParamDebug,
  ve as hashCode,
  Ie as intToRGB,
  Ct as isDebugFromUrlsParams,
  pe as isIframe,
  Ut as isPageLoaded,
  Rt as log,
  Ee as matchPipe,
  St as merge,
  jt as pageLoaded,
  fe as possiblyDeserializeDatarefToValue,
  ue as possiblySerializeValueToDataref,
  Ot as serializeInputs,
  oe as stringToRgb
};
//# sourceMappingURL=index.mjs.map
